export const eng3LetterBig = [
  "Act",
  "Add",
  "Age",
  "Ago",
  "Aid",
  "Aim",
  "Air",
  "All",
  "And",
  "Any",
  "Arm",
  "Art",
  "Ask",
  "Bad",
  "Bag",
  "Ban",
  "Bar",
  "Bed",
  "Bet",
  "Big",
  "Bit",
  "Box",
  "Boy",
  "Bus",
  "But",
  "Buy",
  "Can",
  "Cap",
  "Car",
  "Cat",
  "CEO",
  "Cop",
  "Cow",
  "Cry",
  "Cup",
  "Cut",
  "Dad",
  "Day",
  "Die",
  "Dig",
  "DNA",
  "Dog",
  "Dry",
  "Due",
  "Ear",
  "Eat",
  "Egg",
  "End",
  "Era",
  "Etc",
  "Eye",
  "Fan",
  "Far",
  "Fat",
  "Fee",
  "Few",
  "Fit",
  "Fix",
  "Fly",
  "For",
  "Fun",
  "Gap",
  "Gas",
  "Gay",
  "Get",
  "God",
  "Gun",
  "Guy",
  "Hat",
  "Her",
  "Hey",
  "Him",
  "Hip",
  "His",
  "Hit",
  "Hot",
  "How",
  "Ice",
  "Ill",
  "Its",
  "Jet",
  "Jew",
  "Job",
  "Joy",
  "Key",
  "Kid",
  "Lab",
  "Lap",
  "Law",
  "Lay",
  "Leg",
  "Let",
  "Lie",
  "Lip",
  "Lot",
  "Low",
  "Mad",
  "Man",
  "Map",
  "May",
  "Mix",
  "Hmm",
  "Mom",
  "Mrs",
  "Net",
  "New",
  "Nod",
  "Nor",
  "Not",
  "Now",
  "N't",
  "Nut",
  "Odd",
  "Off",
  "Oil",
  "Old",
  "One",
  "Our",
  "Out",
  "Owe",
  "Own",
  "Pan",
  "Pay",
  "Per",
  "Pet",
  "Pie",
  "Pop",
  "Pot",
  "Put",
  "Raw",
  "Red",
  "Rid",
  "Row",
  "Rub",
  "Run",
  "Sad",
  "Say",
  "Sea",
  "See",
  "Set",
  "Sex",
  "She",
  "Sin",
  "Sir",
  "Sit",
  "Six",
  "Ski",
  "Sky",
  "Son",
  "Sue",
  "Sun",
  "Tap",
  "Tax",
  "Tea",
  "Ten",
  "The",
  "Tie",
  "Tip",
  "Toe",
  "Too",
  "Top",
  "Toy",
  "Try",
  "Two",
  "Use",
  "Via",
  "War",
  "Way",
  "Wet",
  "Who",
  "Why",
  "Win",
  "Yes",
  "Yet",
  "You",
];
export const eng3Lettersmall = [
  "act",
  "add",
  "age",
  "ago",
  "aid",
  "aim",
  "air",
  "all",
  "and",
  "any",
  "arm",
  "art",
  "ask",
  "bad",
  "bag",
  "ban",
  "bar",
  "bed",
  "bet",
  "big",
  "bit",
  "box",
  "boy",
  "bus",
  "but",
  "buy",
  "can",
  "cap",
  "car",
  "cat",
  "ceo",
  "cop",
  "cow",
  "cry",
  "cup",
  "cut",
  "dad",
  "day",
  "die",
  "dig",
  "dna",
  "dog",
  "dry",
  "due",
  "ear",
  "eat",
  "egg",
  "end",
  "era",
  "etc",
  "eye",
  "fan",
  "far",
  "fat",
  "fee",
  "few",
  "fit",
  "fix",
  "fly",
  "for",
  "fun",
  "gap",
  "gas",
  "gay",
  "get",
  "god",
  "gun",
  "guy",
  "hat",
  "her",
  "hey",
  "him",
  "hip",
  "his",
  "hit",
  "hot",
  "how",
  "ice",
  "ill",
  "its",
  "jet",
  "jew",
  "job",
  "joy",
  "key",
  "kid",
  "lab",
  "lap",
  "law",
  "lay",
  "leg",
  "let",
  "lie",
  "lip",
  "lot",
  "low",
  "mad",
  "man",
  "map",
  "may",
  "mix",
  "hmm",
  "mom",
  "mrs",
  "net",
  "new",
  "nod",
  "nor",
  "not",
  "now",
  "n't",
  "nut",
  "odd",
  "off",
  "oil",
  "old",
  "one",
  "our",
  "out",
  "owe",
  "own",
  "pan",
  "pay",
  "per",
  "pet",
  "pie",
  "pop",
  "pot",
  "put",
  "raw",
  "red",
  "rid",
  "row",
  "rub",
  "run",
  "sad",
  "say",
  "sea",
  "see",
  "set",
  "sex",
  "she",
  "sin",
  "sir",
  "sit",
  "six",
  "ski",
  "sky",
  "son",
  "sue",
  "sun",
  "tap",
  "tax",
  "tea",
  "ten",
  "the",
  "tie",
  "tip",
  "toe",
  "too",
  "top",
  "toy",
  "try",
  "two",
  "use",
  "via",
  "war",
  "way",
  "wet",
  "who",
  "why",
  "win",
  "yes",
  "yet",
  "you",
];
export const eng4LetterSmall = [
  "able",
  "acid",
  "aide",
  "aids",
  "ally",
  "also",
  "arab",
  "area",
  "army",
  "auto",
  "away",
  "baby",
  "back",
  "bake",
  "ball",
  "band",
  "bank",
  "base",
  "bean",
  "bear",
  "beat",
  "beer",
  "bell",
  "belt",
  "bend",
  "best",
  "bike",
  "bill",
  "bind",
  "bird",
  "bite",
  "blow",
  "blue",
  "boat",
  "body",
  "bomb",
  "bond",
  "bone",
  "book",
  "boom",
  "boot",
  "born",
  "boss",
  "both",
  "bowl",
  "buck",
  "burn",
  "bury",
  "busy",
  "cake",
  "call",
  "camp",
  "card",
  "care",
  "case",
  "cash",
  "cast",
  "cell",
  "chef",
  "chip",
  "cite",
  "city",
  "club",
  "clue",
  "coal",
  "coat",
  "code",
  "cold",
  "come",
  "cook",
  "cool",
  "cope",
  "copy",
  "core",
  "corn",
  "cost",
  "crew",
  "crop",
  "dare",
  "dark",
  "data",
  "date",
  "dead",
  "deal",
  "dear",
  "debt",
  "deck",
  "deep",
  "deer",
  "deny",
  "desk",
  "diet",
  "dirt",
  "dish",
  "door",
  "down",
  "drag",
  "draw",
  "drop",
  "drug",
  "dust",
  "duty",
  "each",
  "earn",
  "ease",
  "east",
  "easy",
  "edge",
  "else",
  "mail",
  "even",
  "ever",
  "face",
  "fact",
  "fade",
  "fail",
  "fair",
  "fall",
  "farm",
  "fast",
  "fate",
  "fear",
  "feed",
  "feel",
  "file",
  "fill",
  "film",
  "find",
  "fine",
  "fire",
  "firm",
  "fish",
  "five",
  "flag",
  "flat",
  "flee",
  "flow",
  "folk",
  "food",
  "foot",
  "form",
  "four",
  "free",
  "from",
  "fuel",
  "full",
  "fund",
  "gain",
  "game",
  "gang",
  "gate",
  "gaze",
  "gear",
  "gene",
  "gift",
  "girl",
  "give",
  "glad",
  "goal",
  "gold",
  "golf",
  "good",
  "grab",
  "gray",
  "grow",
  "hair",
  "half",
  "hall",
  "hand",
  "hang",
  "hard",
  "hate",
  "have",
  "head",
  "hear",
  "heat",
  "heel",
  "hell",
  "help",
  "here",
  "hero",
  "hide",
  "high",
  "hill",
  "hire",
  "hold",
  "hole",
  "holy",
  "home",
  "hope",
  "host",
  "hour",
  "huge",
  "hurt",
  "idea",
  "into",
  "iron",
  "item",
  "jail",
  "join",
  "joke",
  "jump",
  "jury",
  "just",
  "keep",
  "kick",
  "kill",
  "kind",
  "king",
  "kiss",
  "knee",
  "know",
  "lack",
  "lady",
  "lake",
  "land",
  "last",
  "late",
  "lawn",
  "lead",
  "leaf",
  "lean",
  "left",
  "less",
  "life",
  "lift",
  "like",
  "line",
  "link",
  "list",
  "live",
  "load",
  "loan",
  "lock",
  "long",
  "term",
  "look",
  "lose",
  "loss",
  "lost",
  "lots",
  "loud",
  "love",
  "luck",
  "lung",
  "main",
  "make",
  "male",
  "mall",
  "many",
  "mark",
  "mask",
  "mass",
  "math",
  "meal",
  "mean",
  "meat",
  "meet",
  "menu",
  "mere",
  "mess",
  "milk",
  "mind",
  "mine",
  "miss",
  "mode",
  "mood",
  "moon",
  "more",
  "most",
  "move",
  "much",
  "must",
  "myth",
  "name",
  "near",
  "neck",
  "need",
  "news",
  "next",
  "nice",
  "nine",
  "none",
  "nose",
  "note",
  "odds",
  "okay",
  "once",
  "only",
  "onto",
  "open",
  "oven",
  "over",
  "pace",
  "pack",
  "page",
  "pain",
  "pair",
  "pale",
  "palm",
  "pant",
  "park",
  "part",
  "pass",
  "past",
  "path",
  "peak",
  "peer",
  "pick",
  "pile",
  "pine",
  "pink",
  "pipe",
  "plan",
  "play",
  "plot",
  "plus",
  "poem",
  "poet",
  "pole",
  "poll",
  "pool",
  "poor",
  "port",
  "pose",
  "post",
  "pour",
  "pray",
  "pull",
  "pure",
  "push",
  "quit",
  "race",
  "rail",
  "rain",
  "rank",
  "rare",
  "rate",
  "read",
  "real",
  "rely",
  "rest",
  "rice",
  "rich",
  "ride",
  "ring",
  "rise",
  "risk",
  "road",
  "rock",
  "role",
  "roll",
  "roof",
  "room",
  "root",
  "rope",
  "rose",
  "rule",
  "rush",
  "safe",
  "sake",
  "sale",
  "salt",
  "same",
  "sand",
  "save",
  "seat",
  "seed",
  "seek",
  "seem",
  "self",
  "sell",
  "send",
  "ship",
  "shit",
  "shoe",
  "shop",
  "shot",
  "show",
  "shut",
  "sick",
  "side",
  "sigh",
  "sign",
  "sing",
  "sink",
  "site",
  "size",
  "skin",
  "slip",
  "slow",
  "snap",
  "snow",
  "soft",
  "soil",
  "some",
  "song",
  "soon",
  "sort",
  "soul",
  "soup",
  "spin",
  "spot",
  "star",
  "stay",
  "step",
  "stir",
  "stop",
  "such",
  "suit",
  "sure",
  "swim",
  "tail",
  "take",
  "tale",
  "talk",
  "tall",
  "tank",
  "tape",
  "task",
  "team",
  "tear",
  "teen",
  "tell",
  "tend",
  "tent",
  "test",
  "text",
  "than",
  "that",
  "them",
  "then",
  "they",
  "thin",
  "this",
  "thus",
  "time",
  "tiny",
  "tire",
  "tone",
  "tool",
  "toss",
  "tour",
  "town",
  "tree",
  "trip",
  "true",
  "tube",
  "turn",
  "twin",
  "type",
  "ugly",
  "unit",
  "upon",
  "urge",
  "used",
  "user",
  "vary",
  "vast",
  "very",
  "view",
  "vote",
  "wage",
  "wait",
  "wake",
  "walk",
  "wall",
  "want",
  "warm",
  "warn",
  "wash",
  "wave",
  "weak",
  "wear",
  "week",
  "well",
  "west",
  "what",
  "when",
  "whom",
  "wide",
  "wife",
  "wild",
  "will",
  "wind",
  "wine",
  "wing",
  "wipe",
  "wire",
  "wise",
  "wish",
  "with",
  "wood",
  "word",
  "work",
  "wrap",
  "yard",
  "yeah",
  "year",
  "yell",
  "your",
  "zone",
];
export const eng4LetterBig = [
  "Able",
  "Acid",
  "Aide",
  "AIDS",
  "Ally",
  "Also",
  "Arab",
  "Area",
  "Army",
  "Auto",
  "Away",
  "Baby",
  "Back",
  "Bake",
  "Ball",
  "Band",
  "Bank",
  "Base",
  "Bean",
  "Bear",
  "Beat",
  "Beer",
  "Bell",
  "Belt",
  "Bend",
  "Best",
  "Bike",
  "Bill",
  "Bind",
  "Bird",
  "Bite",
  "Blow",
  "Blue",
  "Boat",
  "Body",
  "Bomb",
  "Bond",
  "Bone",
  "Book",
  "Boom",
  "Boot",
  "Born",
  "Boss",
  "Both",
  "Bowl",
  "Buck",
  "Burn",
  "Bury",
  "Busy",
  "Cake",
  "Call",
  "Camp",
  "Card",
  "Care",
  "Case",
  "Cash",
  "Cast",
  "Cell",
  "Chef",
  "Chip",
  "Cite",
  "City",
  "Club",
  "Clue",
  "Coal",
  "Coat",
  "Code",
  "Cold",
  "Come",
  "Cook",
  "Cool",
  "Cope",
  "Copy",
  "Core",
  "Corn",
  "Cost",
  "Crew",
  "Crop",
  "Dare",
  "Dark",
  "Data",
  "Date",
  "Dead",
  "Deal",
  "Dear",
  "Debt",
  "Deck",
  "Deep",
  "Deer",
  "Deny",
  "Desk",
  "Diet",
  "Dirt",
  "Dish",
  "Door",
  "Down",
  "Drag",
  "Draw",
  "Drop",
  "Drug",
  "Dust",
  "Duty",
  "Each",
  "Earn",
  "Ease",
  "East",
  "Easy",
  "Edge",
  "Else",
  "Mail",
  "Even",
  "Ever",
  "Face",
  "Fact",
  "Fade",
  "Fail",
  "Fair",
  "Fall",
  "Farm",
  "Fast",
  "Fate",
  "Fear",
  "Feed",
  "Feel",
  "File",
  "Fill",
  "Film",
  "Find",
  "Fine",
  "Fire",
  "Firm",
  "Fish",
  "Five",
  "Flag",
  "Flat",
  "Flee",
  "Flow",
  "Folk",
  "Food",
  "Foot",
  "Form",
  "Four",
  "Free",
  "From",
  "Fuel",
  "Full",
  "Fund",
  "Gain",
  "Game",
  "Gang",
  "Gate",
  "Gaze",
  "Gear",
  "Gene",
  "Gift",
  "Girl",
  "Give",
  "Glad",
  "Goal",
  "Gold",
  "Golf",
  "Good",
  "Grab",
  "Gray",
  "Grow",
  "Hair",
  "Half",
  "Hall",
  "Hand",
  "Hang",
  "Hard",
  "Hate",
  "Have",
  "Head",
  "Hear",
  "Heat",
  "Heel",
  "Hell",
  "Help",
  "Here",
  "Hero",
  "Hide",
  "High",
  "Hill",
  "Hire",
  "Hold",
  "Hole",
  "Holy",
  "Home",
  "Hope",
  "Host",
  "Hour",
  "Huge",
  "Hurt",
  "Idea",
  "Into",
  "Iron",
  "Item",
  "Jail",
  "Join",
  "Joke",
  "Jump",
  "Jury",
  "Just",
  "Keep",
  "Kick",
  "Kill",
  "Kind",
  "King",
  "Kiss",
  "Knee",
  "Know",
  "Lack",
  "Lady",
  "Lake",
  "Land",
  "Last",
  "Late",
  "Lawn",
  "Lead",
  "Leaf",
  "Lean",
  "Left",
  "Less",
  "Life",
  "Lift",
  "Like",
  "Line",
  "Link",
  "List",
  "Live",
  "Load",
  "Loan",
  "Lock",
  "Long",
  "Long",
  "Term",
  "Look",
  "Lose",
  "Loss",
  "Lost",
  "Lots",
  "Loud",
  "Love",
  "Luck",
  "Lung",
  "Mail",
  "Main",
  "Make",
  "Male",
  "Mall",
  "Many",
  "Mark",
  "Mask",
  "Mass",
  "Math",
  "Meal",
  "Mean",
  "Meat",
  "Meet",
  "Menu",
  "Mere",
  "Mess",
  "Milk",
  "Mind",
  "Mine",
  "Miss",
  "Mode",
  "Mood",
  "Moon",
  "More",
  "Most",
  "Move",
  "Much",
  "Must",
  "Myth",
  "Name",
  "Near",
  "Neck",
  "Need",
  "News",
  "Next",
  "Nice",
  "Nine",
  "None",
  "Nose",
  "Note",
  "Odds",
  "Okay",
  "Once",
  "Only",
  "Onto",
  "Open",
  "Oven",
  "Over",
  "Pace",
  "Pack",
  "Page",
  "Pain",
  "Pair",
  "Pale",
  "Palm",
  "Pant",
  "Park",
  "Part",
  "Pass",
  "Past",
  "Path",
  "Peak",
  "Peer",
  "Pick",
  "Pile",
  "Pine",
  "Pink",
  "Pipe",
  "Plan",
  "Play",
  "Plot",
  "Plus",
  "Poem",
  "Poet",
  "Pole",
  "Poll",
  "Pool",
  "Poor",
  "Port",
  "Pose",
  "Post",
  "Pour",
  "Pray",
  "Pull",
  "Pure",
  "Push",
  "Quit",
  "Race",
  "Rail",
  "Rain",
  "Rank",
  "Rare",
  "Rate",
  "Read",
  "Real",
  "Rely",
  "Rest",
  "Rice",
  "Rich",
  "Ride",
  "Ring",
  "Rise",
  "Risk",
  "Road",
  "Rock",
  "Role",
  "Roll",
  "Roof",
  "Room",
  "Root",
  "Rope",
  "Rose",
  "Rule",
  "Rush",
  "Safe",
  "Sake",
  "Sale",
  "Salt",
  "Same",
  "Sand",
  "Save",
  "Seat",
  "Seed",
  "Seek",
  "Seem",
  "Self",
  "Sell",
  "Send",
  "Ship",
  "Shit",
  "Shoe",
  "Shop",
  "Shot",
  "Show",
  "Shut",
  "Sick",
  "Side",
  "Sigh",
  "Sign",
  "Sing",
  "Sink",
  "Site",
  "Size",
  "Skin",
  "Slip",
  "Slow",
  "Snap",
  "Snow",
  "Soft",
  "Soil",
  "Some",
  "Song",
  "Soon",
  "Sort",
  "Soul",
  "Soup",
  "Spin",
  "Spot",
  "Star",
  "Stay",
  "Step",
  "Stir",
  "Stop",
  "Such",
  "Suit",
  "Sure",
  "Swim",
  "Tail",
  "Take",
  "Tale",
  "Talk",
  "Tall",
  "Tank",
  "Tape",
  "Task",
  "Team",
  "Tear",
  "Teen",
  "Tell",
  "Tend",
  "Tent",
  "Term",
  "Test",
  "Text",
  "Than",
  "That",
  "Them",
  "Then",
  "They",
  "Thin",
  "This",
  "Thus",
  "Time",
  "Tiny",
  "Tire",
  "Tone",
  "Tool",
  "Toss",
  "Tour",
  "Town",
  "Tree",
  "Trip",
  "True",
  "Tube",
  "Turn",
  "Twin",
  "Type",
  "Ugly",
  "Unit",
  "Upon",
  "Urge",
  "Used",
  "User",
  "Vary",
  "Vast",
  "Very",
  "View",
  "Vote",
  "Wage",
  "Wait",
  "Wake",
  "Walk",
  "Wall",
  "Want",
  "Warm",
  "Warn",
  "Wash",
  "Wave",
  "Weak",
  "Wear",
  "Week",
  "Well",
  "West",
  "What",
  "When",
  "Whom",
  "Wide",
  "Wife",
  "Wild",
  "Will",
  "Wind",
  "Wine",
  "Wing",
  "Wipe",
  "Wire",
  "Wise",
  "Wish",
  "With",
  "Wood",
  "Word",
  "Work",
  "Wrap",
  "Yard",
  "Yeah",
  "Year",
  "Yell",
  "Your",
  "Zone",
];

export const eng5LetterBig = [
  "About",
  "Above",
  "Abuse",
  "Actor",
  "Adapt",
  "Admit",
  "Adopt",
  "Adult",
  "After",
  "Again",
  "Agent",
  "Agree",
  "Ahead",
  "Album",
  "Alive",
  "Allow",
  "Alone",
  "Along",
  "Alter",
  "Among",
  "Anger",
  "Angle",
  "Angry",
  "Apart",
  "Apple",
  "Apply",
  "Argue",
  "Arise",
  "Armed",
  "Asian",
  "Aside",
  "Asset",
  "Avoid",
  "Award",
  "Aware",
  "Awful",
  "Badly",
  "Basic",
  "Basis",
  "Beach",
  "Begin",
  "Being",
  "Below",
  "Bench",
  "Bible",
  "Birth",
  "Black",
  "Blade",
  "Blame",
  "Blind",
  "Block",
  "Blood",
  "Board",
  "Brain",
  "Brand",
  "Bread",
  "Break",
  "Brick",
  "Brief",
  "Bring",
  "Broad",
  "Brown",
  "Brush",
  "Build",
  "Bunch",
  "Buyer",
  "Cabin",
  "Cable",
  "Carry",
  "Catch",
  "Cause",
  "Chain",
  "Chair",
  "Chart",
  "Chase",
  "Cheap",
  "Check",
  "Cheek",
  "Chest",
  "Chief",
  "Child",
  "Civil",
  "Claim",
  "Class",
  "Clean",
  "Clear",
  "Climb",
  "Clock",
  "Close",
  "Cloud",
  "Coach",
  "Coast",
  "Color",
  "Couch",
  "Could",
  "Count",
  "Court",
  "Cover",
  "Crack",
  "Craft",
  "Crash",
  "Crazy",
  "Cream",
  "Crime",
  "Cross",
  "Crowd",
  "Cycle",
  "Daily",
  "Dance",
  "Death",
  "Delay",
  "Depth",
  "Dirty",
  "Doubt",
  "Dozen",
  "Draft",
  "Drama",
  "Dream",
  "Dress",
  "Drink",
  "Drive",
  "Eager",
  "Early",
  "Earth",
  "Eight",
  "Elect",
  "Elite",
  "Empty",
  "Enemy",
  "Enjoy",
  "Enter",
  "Entry",
  "Equal",
  "Error",
  "Essay",
  "Event",
  "Every",
  "Exact",
  "Exist",
  "Extra",
  "Faith",
  "False",
  "Fault",
  "Favor",
  "Fence",
  "Fewer",
  "Fiber",
  "Field",
  "Fifth",
  "Fifty",
  "Fight",
  "Final",
  "First",
  "Flame",
  "Flesh",
  "Float",
  "Floor",
  "Focus",
  "Force",
  "Forth",
  "Found",
  "Frame",
  "Fresh",
  "Front",
  "Fruit",
  "Fully",
  "Funny",
  "Ghost",
  "Giant",
  "Given",
  "Glass",
  "Glove",
  "Grade",
  "Grain",
  "Grand",
  "Grant",
  "Grass",
  "Grave",
  "Great",
  "Green",
  "Group",
  "Guard",
  "Guess",
  "Guest",
  "Guide",
  "Habit",
  "Happy",
  "Heart",
  "Heavy",
  "Hello",
  "Honey",
  "Honor",
  "Horse",
  "Hotel",
  "House",
  "Human",
  "Humor",
  "Ideal",
  "Image",
  "Imply",
  "Index",
  "Inner",
  "Iraqi",
  "Irish",
  "Issue",
  "Joint",
  "Judge",
  "Juice",
  "Knife",
  "Knock",
  "Label",
  "Labor",
  "Large",
  "Later",
  "Latin",
  "Laugh",
  "Layer",
  "Learn",
  "Least",
  "Leave",
  "Legal",
  "Lemon",
  "Level",
  "Light",
  "Limit",
  "Local",
  "Loose",
  "Lover",
  "Lower",
  "Lucky",
  "Lunch",
  "Major",
  "Maker",
  "Marry",
  "Match",
  "Maybe",
  "Mayor",
  "Media",
  "Metal",
  "Meter",
  "Might",
  "Minor",
  "Model",
  "Money",
  "Month",
  "Moral",
  "Motor",
  "Mount",
  "Mouse",
  "Mouth",
  "Movie",
  "Music",
  "Naked",
  "Nerve",
  "Never",
  "Newly",
  "Night",
  "Noise",
  "North",
  "Novel",
  "Nurse",
  "Occur",
  "Ocean",
  "Offer",
  "Often",
  "Onion",
  "Order",
  "Other",
  "Ought",
  "Owner",
  "Paint",
  "Panel",
  "Paper",
  "Party",
  "Patch",
  "Pause",
  "Peace",
  "Phase",
  "Phone",
  "Photo",
  "Piano",
  "Piece",
  "Pilot",
  "Pitch",
  "Place",
  "Plane",
  "Plant",
  "Plate",
  "Point",
  "Porch",
  "Pound",
  "Power",
  "Press",
  "Price",
  "Pride",
  "Prime",
  "Print",
  "Prior",
  "Proof",
  "Proud",
  "Prove",
  "Quick",
  "Quiet",
  "Quite",
  "Quote",
  "Radio",
  "Raise",
  "Range",
  "Rapid",
  "Ratio",
  "Reach",
  "React",
  "Ready",
  "Refer",
  "Relax",
  "Reply",
  "Rifle",
  "Right",
  "River",
  "Rough",
  "Round",
  "Route",
  "Rural",
  "Salad",
  "Sales",
  "Sauce",
  "Scale",
  "Scene",
  "Scope",
  "Score",
  "Seize",
  "Sense",
  "Serve",
  "Seven",
  "Shade",
  "Shake",
  "Shall",
  "Shape",
  "Share",
  "Sharp",
  "Sheet",
  "Shelf",
  "Shell",
  "Shift",
  "Shine",
  "Shirt",
  "Shock",
  "Shoot",
  "Shore",
  "Short",
  "Shout",
  "Shrug",
  "Sight",
  "Since",
  "Skill",
  "Slave",
  "Sleep",
  "Slice",
  "Slide",
  "Small",
  "Smart",
  "Smell",
  "Smile",
  "Smoke",
  "Solar",
  "Solid",
  "Solve",
  "Sorry",
  "Sound",
  "South",
  "Space",
  "Speak",
  "Speed",
  "Spend",
  "Split",
  "Sport",
  "Staff",
  "Stage",
  "Stair",
  "Stake",
  "Stand",
  "Stare",
  "Start",
  "State",
  "Steal",
  "Steel",
  "Stick",
  "Still",
  "Stock",
  "Stone",
  "Store",
  "Storm",
  "Story",
  "Strip",
  "Study",
  "Stuff",
  "Style",
  "Sugar",
  "Super",
  "Swear",
  "Sweep",
  "Sweet",
  "Swing",
  "Table",
  "Taste",
  "Teach",
  "Terms",
  "Thank",
  "Their",
  "Theme",
  "There",
  "These",
  "Thick",
  "Thing",
  "Think",
  "Third",
  "Those",
  "Three",
  "Throw",
  "Tight",
  "Tired",
  "Title",
  "Today",
  "Tooth",
  "Topic",
  "Total",
  "Touch",
  "Tough",
  "Tower",
  "Trace",
  "Track",
  "Trade",
  "Trail",
  "Train",
  "Treat",
  "Trend",
  "Trial",
  "Tribe",
  "Trick",
  "Troop",
  "Truck",
  "Truly",
  "Trust",
  "Truth",
  "Twice",
  "Uncle",
  "Under",
  "Union",
  "Until",
  "Upper",
  "Urban",
  "Usual",
  "Value",
  "Video",
  "Virus",
  "Visit",
  "Vital",
  "Voice",
  "Voter",
  "Waste",
  "Watch",
  "Water",
  "Weigh",
  "Wheel",
  "Where",
  "Which",
  "While",
  "White",
  "Whole",
  "Whose",
  "Woman",
  "Works",
  "World",
  "Worry",
  "Worth",
  "Would",
  "Wound",
  "Write",
  "Wrong",
  "Yield",
  "Young",
  "Yours",
  "Youth",
];
export const eng5LetterSmall = [
  "about",
  "above",
  "abuse",
  "actor",
  "adapt",
  "admit",
  "adopt",
  "adult",
  "after",
  "again",
  "agent",
  "agree",
  "ahead",
  "album",
  "alive",
  "allow",
  "alone",
  "along",
  "alter",
  "among",
  "anger",
  "angle",
  "angry",
  "apart",
  "apple",
  "apply",
  "argue",
  "arise",
  "armed",
  "asian",
  "aside",
  "asset",
  "avoid",
  "award",
  "aware",
  "awful",
  "badly",
  "basic",
  "basis",
  "beach",
  "begin",
  "being",
  "below",
  "bench",
  "bible",
  "birth",
  "black",
  "blade",
  "blame",
  "blind",
  "block",
  "blood",
  "board",
  "brain",
  "brand",
  "bread",
  "break",
  "brick",
  "brief",
  "bring",
  "broad",
  "brown",
  "brush",
  "build",
  "bunch",
  "buyer",
  "cabin",
  "cable",
  "carry",
  "catch",
  "cause",
  "chain",
  "chair",
  "chart",
  "chase",
  "cheap",
  "check",
  "cheek",
  "chest",
  "chief",
  "child",
  "civil",
  "claim",
  "class",
  "clean",
  "clear",
  "climb",
  "clock",
  "close",
  "cloud",
  "coach",
  "coast",
  "color",
  "couch",
  "could",
  "count",
  "court",
  "cover",
  "crack",
  "craft",
  "crash",
  "crazy",
  "cream",
  "crime",
  "cross",
  "crowd",
  "cycle",
  "daily",
  "dance",
  "death",
  "delay",
  "depth",
  "dirty",
  "doubt",
  "dozen",
  "draft",
  "drama",
  "dream",
  "dress",
  "drink",
  "drive",
  "eager",
  "early",
  "earth",
  "eight",
  "elect",
  "elite",
  "empty",
  "enemy",
  "enjoy",
  "enter",
  "entry",
  "equal",
  "error",
  "essay",
  "event",
  "every",
  "exact",
  "exist",
  "extra",
  "faith",
  "false",
  "fault",
  "favor",
  "fence",
  "fewer",
  "fiber",
  "field",
  "fifth",
  "fifty",
  "fight",
  "final",
  "first",
  "flame",
  "flesh",
  "float",
  "floor",
  "focus",
  "force",
  "forth",
  "found",
  "frame",
  "fresh",
  "front",
  "fruit",
  "fully",
  "funny",
  "ghost",
  "giant",
  "given",
  "glass",
  "glove",
  "grade",
  "grain",
  "grand",
  "grant",
  "grass",
  "grave",
  "great",
  "green",
  "group",
  "guard",
  "guess",
  "guest",
  "guide",
  "habit",
  "happy",
  "heart",
  "heavy",
  "hello",
  "honey",
  "honor",
  "horse",
  "hotel",
  "house",
  "human",
  "humor",
  "ideal",
  "image",
  "imply",
  "index",
  "inner",
  "iraqi",
  "irish",
  "issue",
  "joint",
  "judge",
  "juice",
  "knife",
  "knock",
  "label",
  "labor",
  "large",
  "later",
  "latin",
  "laugh",
  "layer",
  "learn",
  "least",
  "leave",
  "legal",
  "lemon",
  "level",
  "light",
  "limit",
  "local",
  "loose",
  "lover",
  "lower",
  "lucky",
  "lunch",
  "major",
  "maker",
  "marry",
  "match",
  "maybe",
  "mayor",
  "media",
  "metal",
  "meter",
  "might",
  "minor",
  "model",
  "money",
  "month",
  "moral",
  "motor",
  "mount",
  "mouse",
  "mouth",
  "movie",
  "music",
  "naked",
  "nerve",
  "never",
  "newly",
  "night",
  "noise",
  "north",
  "novel",
  "nurse",
  "occur",
  "ocean",
  "offer",
  "often",
  "onion",
  "order",
  "other",
  "ought",
  "owner",
  "paint",
  "panel",
  "paper",
  "party",
  "patch",
  "pause",
  "peace",
  "phase",
  "phone",
  "photo",
  "piano",
  "piece",
  "pilot",
  "pitch",
  "place",
  "plane",
  "plant",
  "plate",
  "point",
  "porch",
  "pound",
  "power",
  "press",
  "price",
  "pride",
  "prime",
  "print",
  "prior",
  "proof",
  "proud",
  "prove",
  "quick",
  "quiet",
  "quite",
  "quote",
  "radio",
  "raise",
  "range",
  "rapid",
  "ratio",
  "reach",
  "react",
  "ready",
  "refer",
  "relax",
  "reply",
  "rifle",
  "right",
  "river",
  "rough",
  "round",
  "route",
  "rural",
  "salad",
  "sales",
  "sauce",
  "scale",
  "scene",
  "scope",
  "score",
  "seize",
  "sense",
  "serve",
  "seven",
  "shade",
  "shake",
  "shall",
  "shape",
  "share",
  "sharp",
  "sheet",
  "shelf",
  "shell",
  "shift",
  "shine",
  "shirt",
  "shock",
  "shoot",
  "shore",
  "short",
  "shout",
  "shrug",
  "sight",
  "since",
  "skill",
  "slave",
  "sleep",
  "slice",
  "slide",
  "small",
  "smart",
  "smell",
  "smile",
  "smoke",
  "solar",
  "solid",
  "solve",
  "sorry",
  "sound",
  "south",
  "space",
  "speak",
  "speed",
  "spend",
  "split",
  "sport",
  "staff",
  "stage",
  "stair",
  "stake",
  "stand",
  "stare",
  "start",
  "state",
  "steal",
  "steel",
  "stick",
  "still",
  "stock",
  "stone",
  "store",
  "storm",
  "story",
  "strip",
  "study",
  "stuff",
  "style",
  "sugar",
  "super",
  "swear",
  "sweep",
  "sweet",
  "swing",
  "table",
  "taste",
  "teach",
  "terms",
  "thank",
  "their",
  "theme",
  "there",
  "these",
  "thick",
  "thing",
  "think",
  "third",
  "those",
  "three",
  "throw",
  "tight",
  "tired",
  "title",
  "today",
  "tooth",
  "topic",
  "total",
  "touch",
  "tough",
  "tower",
  "trace",
  "track",
  "trade",
  "trail",
  "train",
  "treat",
  "trend",
  "trial",
  "tribe",
  "trick",
  "troop",
  "truck",
  "truly",
  "trust",
  "truth",
  "twice",
  "uncle",
  "under",
  "union",
  "until",
  "upper",
  "urban",
  "usual",
  "value",
  "video",
  "virus",
  "visit",
  "vital",
  "voice",
  "voter",
  "waste",
  "watch",
  "water",
  "weigh",
  "wheel",
  "where",
  "which",
  "while",
  "white",
  "whole",
  "whose",
  "woman",
  "works",
  "world",
  "worry",
  "worth",
  "would",
  "wound",
  "write",
  "wrong",
  "yield",
  "young",
  "yours",
  "youth",
];
export const engUguulber = [
  "She drew crude hearts on the ground to show how much she loved him."
  ,"Please get me some ice cubes to put in my soda."
  ,"I asked my boss for feedback on my work."
  ,"When he failed the test, his ignorance of math was obvious."
  ,"The road was situated between the forest and the lake.","Water flows down several brooks on the mountain.","Bill was too sick to get out of bed, so his nurse catered to his needs. Bill was too sick to get out of bed, so his nurse catered to his needs.","The considerate boy gave a present to his girlfriend on Valentine’s Day.","These apples are too rotten for consumption.","The men took their hounds with them when they went on the hunting trip.","The watch mechanism is extremely intricate and very difficult to repair.","The tiled floor is installed in an intricate pattern.","The extra cost of travelling to work is offset by the lower price of houses here.","The whale submerged its huge body into the ocean.","I recycle everything I can, so my conscience is clear!","Carol fainted because she had not eaten in over a day.","I am a bit ignorant about his theories. Can you explain them to me?","When I go to the gymnasium, I use the treadmill for 20 minutes.","At New Year, I made a list of resolutions to help me have a better year.","This is an important, formal project and must be typewritten.","My best friend’s dad is a bit weird.","Unit 11. How a singer helped win the war. ","The junior executives formed an alliance with each other.","At the end of speech, everyone gave applause.","This book is an authoritative source on Ancient Egypt's Queen Nefertiti.","Ancient Mexican culture is renowned for its architecture.","The air force works in defense of its country.","Jane told ben all the details of her trip to China.","Big cities have diverse populations with people of different races and ages.","The beautiful woman enchanted everybody in the room.","Steve was equipped with the tools needed to do the job.","Most students thought the test was hard, but Tim was the exception.","She is considered a master in the comedy genre. ","The store lures people in with big signs that say 'Sale!'.","Climbing over the giant rock was the biggest obstacle for the hikers.","The frog took shelter from the storm in a nearby case.","He sorted his clothes by colors and sizes.","The water heater supplied the house with warm water.","Rebecca is so vain that she looks at herself in every mirror.","He made a bid to become the university’s next president.","He showed disrespect by arguing with his boss during a meeting.","The crowd showed their enthusiasm for the soccer team cheering loudly.","The woman leaned against the counter because she was tired.","Ted began setting the table. In the meantime, I began preparing the food. ","Ben was up to mischief when he persuaded ken to paint his face.","She went to the gym to make her muscles stronger.","The firefighter rescued the man from the burning building.","The student said the letters of the alphabet in succession.","The terrain below was rocky and full of hills. ","The timid child hides behind her mother whenever she sees a stranger.","The boy hit his brother in an act of violence.","The student’s poor attitude affected the other students in the class.","Beads of water collected outside the glass.","Please brew a fresh pot of coffee.","Gail charmed everyone with her humorous stories.","It was his destiny to become a great singer.","She is irritable when she does not get enough sleep.","The girl on rollerblades lagged the little girl on the bicycle.","Businesses try to maximize their profits.","The girl was scared to go back to sleep because she had a nightmare. ","Mangoes are one of the most nutritious fruits in the world.","Fish and beef are good sources of protein.","Breathing is one of the subconscious things that the body does.","The delivery company uses large vans to deliver packages.","The lifeguard warned people to stay away from the rough ocean.","She does not do her workout at the weekends.","The cars zoomed along the road.","The old house’s walls crumbled into a pile of rock and wood.","I made heart-shaped cookies from the dough.","The nurse expressed her sympathy for the sick patient.","The bully made a fist and threatened to hit the small boy.","After the long race, the runner’s face was flushed.","The car crash injured two people.","The artist took a lump of clay and turned it into a beautiful pot.","The walls were built using a mixture of water, rock, and dirt.","After arguing, the two friends reconciled with each other.","Our walk in the park was ruined by the sudden rain.","When the ball hit the window, the glass shattered. ","Mr. Smith closed the shutters every night to make his bedroom dark.","The baker sifted the flour into a large bowl.","There was only a slight change in the little boy’s height.","The stars sparkled in the winter night’s sky.","I sprinkled some sugar on top of the cake.","He sprinkled the pasta with salt and black pepper.","The cookies sat on the table so long that they became stale.","The lost boy was so scared that he could barely utter a single word.","We have witnessed the most appalling scenes of human misery.","The course required no prior knowledge of Spanish.","There are a variety of flowers at the shop.","The company stopped using sugar altogether in its food.","The victims of the flood were bound by their need to help each other.","She got a bruise on her knee from falling.","It is a custom that the bride and groom have the first dance. ","The disobedient children did not listen to their mother and had an accident. ","She glimpsed outside the window as the plane was about to land.","The boys tried to toss the ball through the basketball hoop. ","His family helped him when he encountered misfortune.","He pleaded with his parents to let him go to the soccer game.","She ripped the paper in half by accident.","The parents worked hard for their children’s sake.","I accidentally scraped the paint off the side of the car.","The river was the source of drinking water for the village.","The stern teacher did not allow the students to speak during class.","My grandmother stitched the pieces together to make a big blanket.","They heard the thump when the bowling ball hit the floor.","I was vehement when I found out that My son was bad in school.","he couldn't go to practice because he had several errands to do.","They withheld all information until she paid her fine.","He lost his balance while snowboarding and tumbled to the ground.","After the phone call, Monica was very tense.","He stumbled as he ran through the puddle.","He staggered around after having too much to drink.","He was so hungry that he snatched an apple from a tree.","He placed the spoon on the saucer.","Oliver doesn’t act like a sane person when he is angry.","He lost his balance while snowboarding and tumbled to the ground","He placed the spoon on the saucer.","She wanted to grind the beans, so she could brew some coffee.","The sudden drop in prices upset the equilibrium of the economy.","The pregnant woman was dizzy after standing up too quickly.","The cunning child fooled his parents into thinking that he was kind.","The rings of a tree start forming at its core.","Their mother gave the children consent to go outside and play.","The veterinarian had compassion for the sick little puppy.","I cherish this trophy I won","An esteemed scientist is coming to the university to talk about her discoveries.","An esteemed scientist is coming to the university to talk about her discoveries.","Many people believe that it is ethical to help others in need.","There used to be dinosaurs all over the world, but now they are extinct.","There was a secluded bench in the park.","There are lots of wild animals living in the swamp.","Barley is a grain that is used for animal feed, health food and beer.","A lion is one of the fiercest beasts on Earth.","You must wear protective clothing because the patient’s illness is contagious.","You must wear protective clothing because the patient’s illness is contagious.","The airport workers’ strike led to a crisis at the airport.","They discriminated against her because she was different.","Michael extinguished the small fire with the hose.","The boy enjoys playing with his miniature train set in his bedroom.","Arrive promptly, or we won’t have time to discuss everything.","People like to go to the tropics for vacation because it’s warm.","Arrive promptly, or we won’t have time to discuss everything.","he boy enjoys playing with his miniature train set in his bedroom.","The children harassed their mother because they wanted her attention.","There are a lot of flint tools in the museum.","A plague in Europe killed millions of people.","A riot broke out after the candidate lost the election.","I scribbled a rough diagram of our plan and gave it to him.","He prayed at the shrine for an hour.","We summoned the doctor as soon as we noticed she was sick.","The weather suddenly worsened, and we had to stay inside.","I decided to incorporate a new ingredient into my cake recipe.","Tony rested for brief intervals while he worked in the yard.","I modified my outfit by adding a belt to it.","There are two yellow parallel lines dividing both sides of traffic.","I was amazed when I saw phenomenon of shooting starts.","The careless factory polluted the river with chemicals.","The other students ridicule Peter’s foreign accent.","Using solar energy is good for the environment.","Since I spent all my money, my date with Jane is doomed.","The princess was the heir to the king and queen’s throne.","Karate is a martial art that began many years ago in Japan.","He raises poultry and sells their meat for extra money.","I was impressed by her sheer dedication to jogging.","My stance is that using oil and gas is bad for the environment.","Textile is cloth that has been woven or knitted.","The blue textile was going to be used to make blouses.","The baby wailed because it was hungry.",
  
  "What did you do this week?",
  "What was something fun you did this week?",
  "What was something you had to do this week that you didn't care for?",
  "Did you see anyone this week that you haven't seen for a while?",
  "Did you go visit anyone this week?",
  "Did anyone come to visit your house this week?",
  "Do you have any exciting stories to tell from the past week?",
  "How many brothers and sisters do you have?",
  "Are your brothers and sisters older or younger?",
  "What are their names?",
  "How do you like being a brother?",
  "What are your parents names?",
  "Where does your Dad work?",
  "What does your dad do for a job?",
  "Where does your Mom work?",
  "what does your dad do for a job?",
  "What is your favorite thing to do as a family?",
  "Do you have any pets?",
  "What kind of pets do you have?",
  "What are the names of your pets?",
  "How old are you?",
  "When was your birthday?",
  "What did you do for last birthday?",
  "If you could have the perfect birthday party, what would it be?",
  "What is your favorite food?",
  "What is one thing that your Mom makes for dinner that you just can't stand?",
  "What is your favorite kind of ice cream?",
  "What is your favorite kind of candy?",
  "What is your favorite color?",
  "What is your favorite zoo animal?",
  "What is your favorite time of the year?",
  "Is your bedroom decorated?",
  "How is it decorated?",
  "Do you have to share your bedroom with anyone?",
  "If you could receive one thing in the whole world as a present right now, what would it be?",
  "What do you want to be when you get older?",
  "What is the silliest thing you have ever said or done?",
  "What do you like to spend your allowance on?",
  "What is one thing you don't know how to do that you wish you did?",
  "Where do you go to school?",
  "What grade are you in?",
  "Do you like the grade you are in more or less than last year?",
  "Do you ride the bus to school?",
  "What is your teacher's name?",
  "What is your favorite thing to study at school?",
  "What are you studying in school right now in math?",

  "What is your least favorite thing to study?",
  "Do you have lots of homework to do each night?",
  "Who is your best friend?",
  "What do you like to play at recess?",
  "Do you ever stay home from school sick?",
  "When was the last time you stayed home?",
  "What do you like to do for fun?",
  "Do you play sports?",
  "Which ones?",
  "What is your favorite position to play?",
  "Does your team have a name?",
  "What is your favorite thing to do on the weekend?",
  "Do you prefer to spend your time inside or outside?",
  "Do you like to draw?",
  "What kinds of things do you draw?",
  "What do you do when you get home from school?",
  "Do you like to do puzzles?",
  "What about word puzzles?",
  "Does your family go on a vacation each year?",
  "Where does your family go on vacation?",
  "Where is the most exciting place you have been in the past year?",
  "Do you have a bike?",
  "What does it look like?",
  "What is your favorite TV show?",
  "Why do you like it?",
  "What is your favorite movie ever?",
  "What was the last movie you saw?",
  "Did you like it or not, and why?",
  "What is the best toy that you have?",
  "Do you like to read?",
  "What is your favorite book?",
  "What is your favorite computer game?",
  "Do you like to play video games?",
  "What kind of video game system do you have?",
  "What is your favorite game to ply on the Wii, Xbox, etc?",
  "Do you have a portable game system like a PSP or DS?",
  "Which one?",
  "Do you like to go out to eat?",
  "What is your favorite place to eat?",
  "Who has the best kids meal toys right now?",
  "What kind of music do you like?",
  "What is your favorite song?",
  "Do you like to dance?",
  "Do you know how to play any instruments?",
  "Which one(s)?",
  "Do you like to read your Bible?",
  "Do you have a favorite Bible verse?",
  "What is the funniest name in the Bible?",
  "Do you pray to God every day?",
  "What types of things do you pray for?",
  "Who brings you to church?",
  "Do you like coming to church?",
  "When you think of God, how do you picture him?",
  "Why do you think Jesus decided to come and die for our sins?",
  "Do you talk to your Mom and Dad about Jesus and the Bible?",
  "Do you tell other people about Jesus?",
  "Who have you told about Jesus recently?",
  "Thanks so much.",
  "I really appreciate",
  "Excuse me.",
  "I'm sorry",
  "What do you think?",
  "How does that sound?",
  "I'm learning English.",
  "I don't understand.",
  "Could you repeat that please?",
  "Could you please talk slower?",
  "Thank you. That helps a lot.",
  "How do you spell that?",
  "What do you mean?",
  "Nice to meet you.",
  "Where are you from?",
  "What do you do?",
  "What's your phone number?",
  "Do you have Facebook?",
  "How can I help you?",
  "I'll be with you in a moment.",
  "What time is our meeting?",
  "Be careful.",
  "Be careful driving.",
  "Can you translate this for me?",
  "Chicago is very different from Boston.",
  "Don't worry.",
  "Everyone knows it.",
  "Everything is ready.",
  "Excellent.",
  "From time to time.",
  "Good idea.",
  "He likes it very much.",
  "Help!",
  "He's coming soon.",
  "He's right.",
  "He's very annoying.",
  "He's very famous.",
  "How are you?",
  "How's work going?",
  "Hurry!",
  "I ate already.",
  "I can't hear you.",
  "I'd like to go for a walk.",
  "I don't know how to use it.",
  "I don't like him.",
  "I don't like it.",
  "I don't speak very well.",
  "I don't understand.",
  "I don't want it.",
  "I don't want that.",
  "I don't want to bother you.",
  "I feel good.",
  "If you need my help, please let me know.",
  "I get off of work at 6.",
  "I have a headache.",
  "I hope you and your wife have a nice trip.",
  "I know.",
  "I like her.",
  "I'll call you when I leave.",
  "I'll come back later.",
  "I'll pay.",
  "I'll take it.",
  "I'll take you to the bus stop.",
  "I lost my watch.",
  "I love you.",
  "I'm an American.",
  "I'm cleaning my room.",
  "I'm cold.",
  "I'm coming to pick you up.",
  "I'm going to leave.",
  "I'm good, and you?",
  "I'm happy.",
  "I'm hungry.",
  "I'm married.",
  "I'm not busy.",
  "I'm not married.",
  "I'm not ready yet.",
  "I'm not sure.",
  "I'm sorry, we're sold out.",
  "I'm thirsty.",
  "I'm very busy. I don't have time now.",
  "I need to change clothes.",
  "I need to go home.",
  "I only want a snack.",
  "Is Mr. Smith an American?",
  "Is that enough?",
  "I think it's very good.",
  "I think it tastes good.",
  "I thought the clothes were cheaper.",
  "It's longer than 2 miles.",
  "I've been here for two days.",
  "I've heard Texas is a beautiful place.",
  "I've never seen that before.",
  "I was about to leave the restaurant when my friends arrived.",
  "Just a little.",
  "Just a moment.",
  "Let me check.",
  "Let me think about it.",
  "Let's go have a look.",
  "Let's practice English.",
  "May I speak to Mrs. Smith please?",
  "More than that.",
  "Never mind.",
  "Next time.",
  "No.",
  "Nonsense.",
  "No, thank you.",
  "Nothing else.",
  "Not recently.",
  "Not yet.",
  "Of course.",
  "Okay.",
  "Please fill out this form.",
  "Please write it down.",
  "Really?",
  "Right here.",
  "Right there.",
  "See you later.",
  "See you tomorrow.",
  "See you tonight.",
  "She's pretty.",
  "Sorry to bother you.",
  "Stop!",
  "Take a chance.",
  "Take it outside.",
  "Tell me.",
  "Thanks for everything.",
  "Thanks for your help.",
  "Thank you miss.",
  "Thank you sir.",
  "Thank you very much.",
  "That looks great.",
  "That's alright.",
  "That's enough.",
  "That's fine.",
  "That's it.",
  "That smells bad.",
  "That's not fair.",
  "That's not right.",
  "The book is under the table.",
  "They'll be right back.",
  "They're the same.",
  "They're very busy.",

];

export const mon5LetterSmall = [
  "чимээ",
  "тэрэг",
  "голын",
  "захын",
  "хусан",
  "залуу",
  "миний",
  "өвгөн",
  "тархи",
  "дарам",
  "яршиг",
  "тамхи",
  "үгүйг",
  "ажсан",
  "ачаан",
  "бодон",
  "өгөөд",
  "барин",
  "агаар",
  "дөхөж",
  "нохой",
  "хуцав",
  "нэгэн",
  "ирээд",
  "харан",
  "явааг",
  "тосон",
  "ирлээ",
  "марал",
  "бугын",
  "харах",
  "үргэн",
  "залуу",
  "хариу",
  "өчөөд",
  "гэнэт",
  "санаа",
  "зовон",
  "шүүрч",
  "аглаг",
  "юугаа",
  "сууна",
  "үндэс",
  "гэсэн",
  "санаж",
  "өмнөө",
  "босож",
  "болов",
  "хааяа",
  "нөгөө",
  "билээ",
  "хүрэх",
  "танай",
  "хавьд",
  "эрдэм",
  "гэхэд",
  "тавьж",
  "манай",
  "дуунд",
  "илрэв",
  "уухай",
  "эрдэм",
  "нөгөө",
  "дугуй",
  "болно",
  "эхлэв",
  "эрдэм",
  "ёжтой",
  "үгэнд",
  "албан",
  "унших",
  "ядарч",
  "ирсэн",
  "дээрх",
  "нарыг",
  "мэднэ",
  "чухам",
  "ингэж",
  "царай",
  "болох",
  "асуув",
  "гэдэн",
  "ажилд",
  "хийнэ",
  "өгвөл",
  "нэмэх",
  "хүний",
  "ихээр",
  "зөнөж",
  "үгийг",
  "аргал",
  "янгир",
  "танай",
  "ажлын",
  "манай",
  "элбэг",
  "надад",
  "эмийн",
  "төсөн",
  "амрах",
  "цэцэг",
  "ногоо",
  "бодож",
  "миний",
  "газар",
  "улайв",
  "үгээр",
  "нэмэр",
  "харин",
  "мэдэх",
  "дотор",
  "талыг",
  "барив",
  "дахин",
  "дөрөв",
  "эмгэн",
  "өөдөө",
  "хялам",
  "шална",
  "ядсан",
  "хачин",
  "нэгэн",
  "бараа",
  "уулын",
  "мухар",
  "зожиг",
  "эмийн",
  "байна",
  "асуух",
  "санав",
  "янзын",
  "чихэр",
  "барьж",
  "хотын",
  "гэвэл",
  "эмгэн",
  "өмгөн",
  "анхны",
  "усаар",
  "үзвэл",
  "эсвэл",
  "буруу",
  "ургах",
  "архиа",
  "бодох",
  "санаа",
  "өөрөө",
  "дагаж",
  "хөлөө",
  "билүү",
  "хоног",
  "орчны",
  "өглөө",
  "уусны",
  "дараа",
  "эмгэн",
  "түүнд",
  "ширэн",
  "бараг",
  "эзгүй",
  "хэдэн",
  "явсан",
  "гэтэл",
  "ухаан",
  "зарим",
  "хойно",
  "тэнэж",
  "манай",
  "ихтэй",
  "хэзээ",
  "дотно",
  "юманд",
  "гэтэл",
  "барна",
  "бодис",
  "холих",
  "зарим",
  "харна",
  "бүхэн",
  "сонин",
  "хоёрт",
  "ондоо",
  "үзлээ",
  "яриад",
  "аялан",
  "гарна",
  "залуу",
  "өнөөх",
  "учрыг",
  "гэтэл",
  "орхив",
  "үдийн",
  "хугас",
  "ажлаа",
  "орхиж",
  "миний",
  "уудаг",
  "хүсэл",
  "гэдэг",
  "өссөн",
  "өлгий",
  "иржээ",
  "өвчин",
  "эмгэг",
  "газар",
  "шороо",
  "маань",
  "гэтэл",
  "шигээ",
  "дүлий",
  "годил",
  "хөөрч",
  "яалаа",
  "яалаа",
  "хэрэг",
  "тэнэг",
  "үзээд",
  "илтэд",
  "хамаг",
  "бодол",
  "тусаж",
  "даанч",
  "өвроп",
  "тавин",
  "яриад",
  "жишээ",
  "загас",
  "шувуу",
  "тэгэв",
  "гэтэл",
  "цэвэр",
  "яриад",
  "чухал",
  "моньд",
  "могой",
  "усанд",
  "бузар",
  "золиг",
  "хацар",
  "манай",
  "таван",
  "журам",
  "тухай",
  "өнийн",
  "манай",
  "түмэн",
  "бохир",
  "угааж",
  "асгах",
  "савыг",
  "онцын",
  "ариун",
  "мөрөн",
  "үеийн",
  "угаас",
  "ажлыг",
  "тулан",
  "нэхэн",
  "яриаг",
  "орчих",
  "шахна",
  "эцгээ",
  "төлөө",
  "үедээ",
  "ёстой",
  "зугаа",
  "жижиг",
  "юмгүй",
  "даанч",
  "таних",
  "зарим",
  "машин",
  "албан",
  "жорын",
  "учирч",
  "инээв",
  "өрөөс",
  "явдаг",
  "манай",
  "захиа",
  "занаа",
  "бичиж",
  "итгэл",
  "сураг",
  "томоо",
  "ороод",
  "орлоо",
  "эврэн",
  "аваад",
  "бодий",
  "яваад",
  "гэтэл",
  "ирвэс",
  "мөчий",
  "хадаж",
  "орсон",
  "яасан",
  "эхнэр",
  "чиний",
  "юмаар",
  "нүдээ",
  "зовхи",
  "халав",
  "миний",
  "ердөө",
  "бичнэ",
  "инээж",
  "өвгөн",
  "цалин",
  "гэлээ",
  "миний",
  "яалаа",
  "хүрэв",
  "дэлүү",
  "үдсэн",
  "бүтэн",
  "хөлөө",
  "шахам",
  "хэлэх",
  "гуйвж",
  "чинээ",
  "төдий",
  "аминд",
  "гэрээ",
  "уланд",
  "цохив",
  "элдэв",
  "бичиг",
  "сачиг",
  "ирдэг",
  "чиний",
  "өчсөн",
  "эвгүй",
  "газар",
  "авсан",
  "зөрөө",
  "сохор",
  "жишиж",
  "тэнэг",
  "садаа",
  "цаана",
  "мэдэж",
  "далим",
  "охинд",
  "харин",
  "бураа",
  "авлаа",
  "очоод",
  "талын",
  "алгаа",
  "ажаад",
  "өвдөх",
  "араан",
  "улаан",
  "хацры",
  "алтан",
  "манай",
  "инээд",
  "ачтай",
  "зэрэг",
  "тусыг",
  "эмээж",
  "сахиж",
  "яндан",
  "санах",
  "хүнээ",
  "гадаа",
  "залуу",
  "зүүнэ",
  "бодно",
  "тусам",
  "ялдам",
  "уярна",
  "атган",
  "өргөж",
  "согоо",
  "суман",
  "анчин",
  "анчин",
  "эргэж",
  "очдог",
  "явжээ",
  "эзэлж",
  "гэтэл",
  "алсад",
  "алдав",
  "сэхээ",
  "алдан",
  "учраа",
  "ойгоо",
  "дуулж",
  "аавыг",
  "уяран",
  "таван",
  "хүрэн",
  "элгэн",
  "өгсөн",
  "эмийг",
  "охинд",
  "аягүй",
  "гарах",
  "манай",
  "үүдэн",
  "тэгнэ",
  "эрэгч",
  "олонд",
  "уувал",
  "хярам",
  "ундаа",
  "хэлэв",
  "манай",
  "уртад",
  "цувуу",
  "чиний",
  "өвдөг",
  "уруул",
  "увдис",
  "болор",
  "эмийн",
  "манай",
  "чухаг",
  "ховор",
  "эзнээ",
  "сарны",
  "урсаж",
  "хоёул",
  "гараа",
  "балын",
  "буцах",
  "шүүрс",
  "хотоо",
  "харих",
  "салхи",
  "эсрэг",
  "андах",
  "таныг",
  "үсрэн",
  "араас",
  "холын",
  "дөрөө",
  "туяан",
  "хүрнэ",
  "нарны",
  "дөхөх",
  "наран",
  "сэрүү",
  "татна",
  "цээнэ",
  "улбар",
  "хамар",
  "морьд",
  "зарим",
  "морио",
  "морьд",
  "эндээ",
  "явган",
  "явбал",
  "хором",
  "болон",
  "бодъё",
  "майга",
  "уулын",
  "уулын",
  "хошуу",
  "уулыг",
  "тушаа",
  "эхний",
  "уулан",
  "салхи",
  "нүүнэ",
  "эдэлж",
  "урсах",
  "хаана",
  "жолоо",
  "хөхөж",
  "далай",
  "буцна",
  "юухан",
  "нуран",
  "тамир",
  "барах",
  "асгат",
  "амарч",
  "мацан",
  "оройд",
  "үүлэн",
  "бороо",
  "хөвөн",
  "үсэнд",
  "бороо",
  "эргэн",
  "бороо",
  "эндээ",
  "цочин",
  "хүүгж",
  "удлаа",
  "гэнэт",
  "хүрэх",
  "манан",
  "эмээж",
  "асган",
  "урдах",
  "авирч",
  "алхам",
  "замыг",
  "амран",
  "хэсэг",
  "гурав",
  "босон",
  "залуу",
  "хүний",
  "оргил",
  "бүжин",
  "орчны",
  "агаад",
  "удтал",
  "нэрээ",
  "газар",
  "улсын",
];
export const mon5LetterBig = [
  "Чимээ",
  "Тэрэг",
  "Голын",
  "Захын",
  "Хусан",
  "Залуу",
  "Миний",
  "Өвгөн",
  "Тархи",
  "Дарам",
  "Яршиг",
  "Тамхи",
  "Үгүйг",
  "Ажсан",
  "Залуу",
  "Ачаан",
  "Бодон",
  "Өгөөд",
  "Барин",
  "Агаар",
  "Дөхөж",
  "Нохой",
  "Хуцав",
  "Нэгэн",
  "Ирээд",
  "Харан",
  "Явааг",
  "Ажсан",
  "Тосон",
  "Ирлээ",
  "Марал",
  "Бугын",
  "Харах",
  "Үргэн",
  "Хариу",
  "Өчөөд",
  "Гэнэт",
  "Санаа",
  "Зовон",
  "Залуу",
  "Шүүрч",
  "Аглаг",
  "Юугаа",
  "Сууна",
  "Залуу",
  "Бодон",
  "Хариу",
  "Өвгөн",
  "Нохой",
  "Үндэс",
  "Сууна",
  "Гэсэн",
  "Санаж",
  "Өмнөө",
  "Босож",
  "Болов",
  "Өвгөн",
  "Хааяа",
  "Нөгөө",
  "Билээ",
  "Хүрэх",
  "Танай",
  "Хавьд",
  "Эрдэм",
  "Ирлээ",
  "Гэхэд",
  "Өвгөн",
  "Тавьж",
  "Манай",
  "Дуунд",
  "Илрэв",
  "Залуу",
  "Залуу",
  "Санаж",
  "Өвгөн",
  "Уухай",
  "Дугуй",
  "Өвгөн",
  "Болно",
  "Өвгөн",
  "Эхлэв",
  "Өвгөн",
  "Ёжтой",
  "Үгэнд",
  "Гэсэн",
  "Хариу",
  "Албан",
  "Өвгөн",
  "Унших",
  "Өвгөн",
  "Гэсэн",
  "Ядарч",
  "Ирсэн",
  "Миний",
  "Дээрх",
  "Нарыг",
  "Мэднэ",
  "Өвгөн",
  "Чухам",
  "Ингэж",
  "Царай",
  "Болох",
  "Өвгөн",
  "Асуув",
  "Гэдэн",
  "Ажилд",
  "Хийнэ",
  "Өгвөл",
  "Санаа",
  "Нэмэх",
  "Гэсэн",
  "Хүний",
  "Өвгөн",
  "Ихээр",
  "Зөнөж",
  "Өвгөн",
  "Үгийг",
  "Аргал",
  "Янгир",
  "Ажлын",
  "Элбэг",
  "Үгэнд",
  "Санаа",
  "Залуу",
  "Ингэж",
  "Ингэж",
  "Гэсэн",
  "Надад",
  "Эмийн",
  "Төсөн",
  "Санаа",
  "Амрах",
  "Цэцэг",
  "Ногоо",
  "Бодож",
  "Өвгөн",
  "Гэсэн",
  "Эмийн",
  "Газар",
  "Гэсэн",
  "Өвгөн",
  "Царай",
  "Улайв",
  "Үгээр",
  "Нэмэр",
  "Харин",
  "Мэдэх",
  "Дотор",
  "Талыг",
  "Барив",
  "Өвгөн",
  "Царай",
  "Ажсан",
  "Дахин",
  "Дөрөв",
  "Харан",
  "Газар",
  "Эмгэн",
  "Өвгөн",
  "Өөдөө",
  "Хялам",
  "Хялам",
  "Хүний",
  "Шална",
  "Санаа",
  "Ядсан",
  "Өвгөн",
  "Хачин",
  "Өвгөн",
  "Хүний",
  "Бараа",
  "Уулын",
  "Мухар",
  "Зожиг",
  "Болов",
  "Элбэг",
  "Болов",
  "Байна",
  "Үгэнд",
  "Эрдэм",
  "Болов",
  "Асуух",
  "Болох",
  "Гэнэт",
  "Санав",
  "Болов",
  "Янзын",
  "Чихэр",
  "Барьж",
  "Хотын",
  "Гэвэл",
  "Эмгэн",
  "Тосон",
  "Чихэр",
  "Өмгөн",
  "Анхны",
  "Дахин",
  "Гэхэд",
  "Усаар",
  "Үзвэл",
  "Эмгэн",
  "Өвгөн",
  "Эсвэл",
  "Буруу",
  "Гэсэн",
  "Өвгөн",
  "Ургах",
  "Эмгэн",
  "Архиа",
  "Ингэж",
  "Царай",
  "Өвгөн",
  "Байна",
  "Бодох",
  "Газар",
  "Эмгэн",
  "Өвгөн",
  "Өөрөө",
  "Дагаж",
  "Хөлөө",
  "Билүү",
  "Эмгэн",
  "Хоног",
  "Орчны",
  "Эмийн",
  "Залуу",
  "Өглөө",
  "Уусны",
  "Дараа",
  "Түүнд",
  "Ширэн",
  "Орчны",
  "Бараг",
  "Өвгөн",
  "Эзгүй",
  "Мэдэх",
  "Хэдэн",
  "Явсан",
  "Билээ",
  "Гэтэл",
  "Залуу",
  "Цэцэг",
  "Залуу",
  "Ухаан",
  "Байна",
  "Зарим",
  "Хэдэн",
  "Хойно",
  "Хөлөө",
  "Өвгөн",
  "Ногоо",
  "Ингэж",
  "Тэнэж",
  "Эмгэн",
  "Ингэж",
  "Ихтэй",
  "Газар",
  "Хэзээ",
  "Гэсэн",
  "Дотно",
  "Юманд",
  "Бараа",
  "Эзгүй",
  "Барна",
  "Бодис",
  "Цэцэг",
  "Холих",
  "Цэцэг",
  "Харна",
  "Бүхэн",
  "Сонин",
  "Эмгэн",
  "Хоёрт",
  "Мэдэх",
  "Цэцэг",
  "Ондоо",
  "Үзлээ",
  "Өвгөн",
  "Эмгэн",
  "Яриад",
  "Өвгөн",
  "Өвгөн",
  "Аялан",
  "Гарна",
  "Өнөөх",
  "Цэцэг",
  "Цэцэг",
  "Учрыг",
  "Орхив",
  "Үдийн",
  "Хугас",
  "Өвгөн",
  "Цэцэг",
  "Байна",
  "Ногоо",
  "Хоног",
  "Өвгөн",
  "Гэнэт",
  "Ингэж",
  "Залуу",
  "Ажлаа",
  "Орхиж",
  "Эмийн",
  "Гэхэд",
  "Эмгэн",
  "Уудаг",
  "Өвгөн",
  "Гэсэн",
  "Хүсэл",
  "Газар",
  "Гэдэг",
  "Хүний",
  "Өссөн",
  "Өлгий",
  "Иржээ",
  "Өвчин",
  "Эмгэг",
  "Байна",
  "Шороо",
  "Байна",
  "Байна",
  "Маань",
  "Байна",
  "Дөрөв",
  "Маань",
  "Хүний",
  "Яриад",
  "Санаа",
  "Өвгөн",
  "Харин",
  "Шороо",
  "Шигээ",
  "Гэхэд",
  "Өвгөн",
  "Хоног",
  "Дүлий",
  "Годил",
  "Хөөрч",
  "Яалаа",
  "Өвгөн",
  "Хэрэг",
  "Тэнэг",
  "Санаа",
  "Залуу",
  "Санаа",
  "Үзээд",
  "Илтэд",
  "Харна",
  "Хамаг",
  "Санаа",
  "Бодол",
  "Тусаж",
  "Бүхэн",
  "Даанч",
  "Өвроп",
  "Гэдэг",
  "Тавин",
  "Байна",
  "Жишээ",
  "Гэдэг",
  "Загас",
  "Шувуу",
  "Тэгэв",
  "Гэвэл",
  "Загас",
  "Шувуу",
  "Болох",
  "Манай",
  "Ирсэн",
  "Маань",
  "Байна",
  "Өвгөн",
  "Байна",
  "Нөгөө",
  "Залуу",
  "Цэвэр",
  "Гэдэг",
  "Яриад",
  "Учрыг",
  "Гэхэд",
  "Миний",
  "Болох",
  "Хэрэг",
  "Чухал",
  "Билээ",
  "Түүнд",
  "Болох",
  "Хөлөө",
  "Моньд",
  "Миний",
  "Могой",
  "Усанд",
  "Хүний",
  "Бузар",
  "Золиг",
  "Бодол",
  "Хацар",
  "Ирсэн",
  "Таван",
  "Журам",
  "Гэдэг",
  "Тухай",
  "Билээ",
  "Гэхэд",
  "Өнийн",
  "Өвгөн",
  "Түмэн",
  "Усанд",
  "Бохир",
  "Угааж",
  "Асгах",
  "Савыг",
  "Онцын",
  "Газар",
  "Ариун",
  "Мөрөн",
  "Үеийн",
  "Угаас",
  "Ажлыг",
  "Өвгөн",
  "Тулан",
  "Нэхэн",
  "Санаж",
  "Байна",
  "Яриаг",
  "Орчих",
  "Шахна",
  "Эцгээ",
  "Төлөө",
  "Хэрэг",
  "Түмэн",
  "Үедээ",
  "Элбэг",
  "Зарим",
  "Өвгөн",
  "Ёстой",
  "Зарим",
  "Зугаа",
  "Ёстой",
  "Жижиг",
  "Бодох",
  "Юмгүй",
  "Таних",
  "Машин",
  "Гэсэн",
  "Хүний",
  "Болно",
  "Барьж",
  "Жорын",
  "Учирч",
  "Инээв",
  "Өрөөс",
  "Явдаг",
  "Санаж",
  "Тамхи",
  "Манай",
  "Эрдэм",
  "Ирсэн",
  "Ирсэн",
  "Захиа",
  "Занаа",
  "Бичиж",
  "Хүний",
  "Итгэл",
  "Ажлын",
  "Сураг",
  "Дараа",
  "Байна",
  "Өнөөх",
  "Байна",
  "Томоо",
  "Маань",
  "Ороод",
  "Байна",
  "Бугын",
  "Газар",
  "Орлоо",
  "Гэсэн",
  "Эврэн",
  "Орчих",
  "Газар",
  "Аваад",
  "Ажсан",
  "Өнөөх",
  "Манай",
  "Ажилд",
  "Бодий",
  "Яваад",
  "Миний",
  "Болно",
  "Ирвэс",
  "Мөчий",
  "Хадаж",
  "Орхиж",
  "Миний",
  "Орсон",
  "Гэсэн",
  "Болох",
  "Тэнэг",
  "Яасан",
  "Дотор",
  "Ирсэн",
  "Эхнэр",
  "Чиний",
  "Юмаар",
  "Нүдээ",
  "Зовхи",
  "Ондоо",
  "Босож",
  "Янзын",
  "Харин",
  "Эхнэр",
  "Сонин",
  "Халав",
  "Гэсэн",
  "Маань",
  "Байна",
  "Надад",
  "Ердөө",
  "Бичнэ",
  "Гэдэг",
  "Эхнэр",
  "Инээж",
  "Байна",
  "Эхнэр",
  "Маань",
  "Цалин",
  "Гэлээ",
  "Гэдэг",
  "Цалин",
  "Болох",
  "Нэмэр",
  "Маань",
  "Надад",
  "Нөгөө",
  "Нэмэр",
  "Явдаг",
  "Нэмэр",
  "Хүрэв",
  "Дэлүү",
  "Сонин",
  "Гэхэд",
  "Сонин",
  "Босож",
  "Үдсэн",
  "Дөрөв",
  "Таван",
  "Бүтэн",
  "Эрдэм",
  "Ажлыг",
  "Маань",
  "Миний",
  "Үгэнд",
  "Харин",
  "Инээж",
  "Инээж",
  "Билээ",
  "Шахам",
  "Үзээд",
  "Хэлэх",
  "Гуйвж",
  "Өнөөх",
  "Түмэн",
  "Чинээ",
  "Төдий",
  "Аминд",
  "Гэрээ",
  "Хэрэг",
  "Өвчин",
  "Өвгөн",
  "Инээж",
  "Уланд",
  "Цохив",
  "Дахин",
  "Тамхи",
  "Элдэв",
  "Бичиг",
  "Сачиг",
  "Ирдэг",
  "Хийнэ",
  "Өнөөх",
  "Хэрэг",
  "Өвгөн",
  "Өчсөн",
  "Эвгүй",
  "Яриаг",
  "Өвгөн",
  "Юманд",
  "Бодох",
  "Авсан",
  "Зөрөө",
  "Билээ",
  "Бодож",
  "Болох",
  "Тархи",
  "Өвгөн",
  "Явсан",
  "Сохор",
  "Мухар",
  "Жишиж",
  "Юманд",
  "Садаа",
  "Цаана",
  "Эмгэн",
  "Гэдэг",
  "Болов",
  "Эмгэн",
  "Мэдэж",
  "Хааяа",
  "Далим",
  "Ирсэн",
  "Охинд",
  "Өвгөн",
  "Эмгэн",
  "Дараа",
  "Өвгөн",
  "Гэсэн",
  "Өвгөн",
  "Бураа",
  "Билүү",
  "Эмгэн",
  "Авлаа",
  "Очоод",
  "Хүрэх",
  "Талын",
  "Алгаа",
  "Асуув",
  "Ажаад",
  "Өвдөх",
  "Ингэж",
  "Билээ",
  "Араан",
  "Гэсэн",
  "Улаан",
  "Хацры",
  "Нөгөө",
  "Өглөө",
  "Өвгөн",
  "Эмгэн",
  "Өвгөн",
  "Алтан",
  "Гэдэг",
  "Өвчин",
  "Эмийн",
  "Эмгэн",
  "Нэмэр",
  "Байна",
  "Эмгэг",
  "Инээд",
  "Эмгэн",
  "Ачтай",
  "Гэсэн",
  "Зэрэг",
  "Бараг",
  "Тусыг",
  "Эмгэн",
  "Эмээж",
  "Сонин",
  "Сонин",
  "Өвгөн",
  "Нэгэн",
  "Сахиж",
  "Хааяа",
  "Залуу",
  "Инээж",
  "Яндан",
  "Өвгөн",
  "Санах",
  "Юмгүй",
  "Хүнээ",
  "Гэдэг",
  "Инээд",
  "Гадаа",
  "Цэцэг",
  "Хэзээ",
  "Зүүнэ",
  "Хүний",
  "Бодно",
  "Бодох",
  "Тусам",
  "Ялдам",
  "Уярна",
  "Цэцэг",
  "Атган",
  "Өргөж",
  "Мэдэх",
  "Согоо",
  "Суман",
  "Анчин",
  "Согоо",
  "Санаа",
  "Эргэж",
  "Очдог",
  "Согоо",
  "Дараа",
  "Согоо",
  "Согоо",
  "Суман",
  "Билээ",
  "Өөрөө",
  "Надад",
  "Дотно",
  "Явжээ",
  "Ирээд",
  "Шахам",
  "Эмийн",
  "Эзэлж",
  "Бодол",
  "Билээ",
  "Иржээ",
  "Уулын",
  "Нэгэн",
  "Барьж",
  "Алсад",
  "Харан",
  "Санаа",
  "Алдав",
  "Сэхээ",
  "Цэцэг",
  "Ногоо",
  "Таних",
  "Өмнөө",
  "Алдан",
  "Учраа",
  "Дотор",
  "Ойгоо",
  "Орсон",
  "Тухай",
  "Сонин",
  "Дуулж",
  "Авлаа",
  "Шигээ",
  "Болох",
  "Гэвэл",
  "Зарим",
  "Хүний",
  "Аавыг",
  "Болох",
  "Нүдээ",
  "Инээд",
  "Уяран",
  "Өвгөн",
  "Эмгэн",
  "Тухай",
  "Хүрэн",
  "Миний",
  "Элгэн",
  "Хоёрт",
  "Өгсөн",
  "Эмийг",
  "Өөрөө",
  "Байна",
  "Ингэж",
  "Аягүй",
  "Гарах",
  "Билүү",
  "Мэдэх",
  "Өвгөн",
  "Эмгэн",
  "Үүдэн",
  "Улаан",
  "Эмгэн",
  "Чиний",
  "Хүний",
  "Байна",
  "Өвгөн",
  "Хааяа",
  "Гэвэл",
  "Тэгнэ",
  "Тэгнэ",
  "Эрэгч",
  "Олонд",
  "Нэгэн",
  "Цэцэг",
  "Өөрөө",
  "Гэхэд",
  "Өвгөн",
  "Эмгэн",
  "Уувал",
  "Байна",
  "Хярам",
  "Бичиг",
  "Мэдэх",
  "Гэнэт",
  "Ундаа",
  "Бараг",
  "Зэрэг",
  "Хэлэв",
  "Өвгөн",
  "Хүрэн",
  "Хэдэн",
  "Ирлээ",
  "Уртад",
  "Цувуу",
  "Мэдэх",
  "Байна",
  "Өвдөг",
  "Тавин",
  "Уруул",
  "Өвгөн",
  "Байна",
  "Увдис",
  "Болор",
  "Үндэс",
  "Зарим",
  "Зарим",
  "Талын",
  "Байна",
  "Гэвэл",
  "Хэрэг",
  "Болох",
  "Гэхэд",
  "Чухаг",
  "Ховор",
  "Залуу",
  "Эзнээ",
  "Өвгөн",
  "Эмийн",
  "Болох",
  "Царай",
  "Сарны",
  "Урсаж",
  "Уулын",
  "Голын",
  "Хоёул",
  "Мөрөн",
  "Гараа",
  "Тавьж",
  "Эмийн",
  "Балын",
  "Хоног",
  "Буцах",
  "Маань",
  "Шүүрс",
  "Хотоо",
  "Харих",
  "Байна",
  "Залуу",
  "Гэнэт",
  "Салхи",
  "Чимээ",
  "Юманд",
  "Байна",
  "Залуу",
  "Ингэж",
  "Очоод",
  "Санаа",
  "Цэцэг",
  "Эсрэг",
  "Тухай",
  "Андах",
  "Гэхэд",
  "Залуу",
  "Таныг",
  "Урсаж",
  "Үсрэн",
  "Гэсэн",
  "Шигээ",
  "Аглаг",
  "Цэцэг",
  "Бодон",
  "Араас",
  "Харна",
  "Өвгөн",
  "Газар",
  "Гэсэн",
  "Холын",
  "Дөрөө",
  "Хэзээ",
  "Буцах",
  "Улаан",
  "Туяан",
  "Уулын",
  "Шахам",
  "Хүрнэ",
  "Өвгөн",
  "Нарны",
  "Ингэж",
  "Дөхөх",
  "Тусам",
  "Ногоо",
  "Наран",
  "Сэрүү",
  "Татна",
  "Цээнэ",
  "Улбар",
  "Хүрэн",
  "Цэцэг",
  "Хамар",
  "Морьд",
  "Газар",
  "Морио",
  "Хамар",
  "Хэрэг",
  "Байна",
  "Эндээ",
  "Явган",
  "Явбал",
  "Өвгөн",
  "Хэдэн",
  "Хором",
  "Бодол",
  "Болон",
  "Бодъё",
  "Өвгөн",
  "Майга",
  "Хөлөө",
  "Тавин",
  "Цаана",
  "Хошуу",
  "Уулыг",
  "Тушаа",
  "Болов",
  "Өвгөн",
  "Эхний",
  "Уулан",
  "Өвгөн",
  "Шахам",
  "Нүүнэ",
  "Болон",
  "Нэгэн",
  "Эдэлж",
  "Явсан",
  "Газар",
  "Урсах",
  "Хаана",
  "Байна",
  "Урсах",
  "Жолоо",
  "Алдан",
  "Дагаж",
  "Хүний",
  "Хүний",
  "Хөхөж",
  "Далай",
  "Буцна",
  "Юухан",
  "Инээд",
  "Алдан",
  "Аваад",
  "Гэсэн",
  "Бодол",
  "Санаж",
  "Бодол",
  "Нуран",
  "Тамир",
  "Барах",
  "Асгат",
  "Амарч",
  "Мацан",
  "Оройд",
  "Үүлэн",
  "Ороод",
  "Бороо",
  "Хөвөн",
  "Бороо",
  "Орлоо",
  "Нэгэн",
  "Үсэнд",
  "Эргэн",
  "Бороо",
  "Байна",
  "Гэвэл",
  "Санаа",
  "Болно",
  "Тэгнэ",
  "Уруул",
  "Цочин",
  "Салхи",
  "Хүүгж",
  "Удлаа",
  "Орсон",
  "Шигээ",
  "Бороо",
  "Үсрэн",
  "Ёстой",
  "Манан",
  "Дахин",
  "Болно",
  "Дотор",
  "Асган",
  "Урсах",
  "Болов",
  "Урдах",
  "Өөдөө",
  "Авирч",
  "Алхам",
  "Замыг",
  "Харан",
  "Амран",
  "Нэгэн",
  "Хэсэг",
  "Авирч",
  "Оройд",
  "Наран",
  "Гурав",
  "Байна",
  "Босон",
  "Хүрэв",
  "Ховор",
  "Гараа",
  "Аглаг",
  "Уулын",
  "Хүний",
  "Ингэж",
  "Оргил",
  "Хэсэг",
  "Хэсэг",
  "Бүжин",
  "Агаад",
  "Уулын",
  "Гэхэд",
  "Гэхэд",
  "Удтал",
  "Холын",
  "Нэрээ",
  "Хүний",
  "Түмэн",
  "Увдис",
  "Улсын",
  "Газар",
];
export const mon4LetterSmall = [
  "гээд",
  "хамт",
  "яваа",

  "очих",
  "хага",
  "алга",
  "бэрд",
  "яхир",
  "байх",
  "амар",
  "гарч",
  "дээр",
  "хоёр",
  "ёсыг",
  "явах",
  "байн",
  "гэрт",
  "үест",
  "хүрч",
  "ажээ",
  "ирэх",
  "өгье",
  "өмнө",
  "хийж",
  "үсээ",
  "тойг",
  "зүүн",
  "орны",
  "эмээ",
  "мэнд",
  "зуур",
  "идээ",
  "ажин",
  "ямар",
  "явна",
  "ажил",
  "хийх",
  "өнгө",
  "үнэн",
  "нүүр",
  "гэнэ",
  "зааж",
  "нааш",
  "хааш",
  "үзэх",
  "чамд",
  "шинэ",
  "юунд",
  "минь",
  "өрөм",
  "алив",
  "охин",
  "тавь",
  "хэлж",
  "уруу",
  "чинь",
  "эвий",
  "саад",
  "болж",
  "аяыг",
  "болж",
  "тэгж",
  "ярьж",
  "буга",
  "алах",
  "арьс",
  "эцэг",
  "тийм",
  "одоо",
  "утга",
  "улам",
  "учир",
  "доод",
  "хэгз",
  "зууж",
  "биөэ",
  "ажна",
  "атал",
  "сайт",
  "гэгч",
  "юмаа",
  "одоо",
  "яана",
  "үгүй",
  "хүнд",
  "нээж",
  "лонх",
  "боов",
  "буян",
  "яваг",
  "галд",
  "өгөх",
  "хойш",
  "арга",
  "тээр",
  "одно",
  "идэх",
  "боож",
  "өгнө",
  "хээр",
  "удаа",
  "чигт",
  "авах",
  "өдөр",
  "давж",
  "шөнө",
  "арай",
  "ядан",
  "ирнэ",
  "хавь",
  "бууг",
  "яриа",
  "цөөн",
  "хань",
  "ижил",
  "өөрт",
  "байж",
  "ганц",
  "үзнэ",
  "очиж",
  "харж",
  "сахь",
  "овыг",
  "багш",
  "олон",
  "ярих",
  "авъя",
  "түүн",
  "эмэн",
  "сөөм",
  "төрж",
  "гуай",
  "баян",
  "амин",
  "хөрс",
  "сууж",
  "одоо",
  "ихэд",
  "төгс",
  "тивд",
  "өвөг",
  "түүр",
  "зуун",
  "удам",
  "ялаа",
  "нүүж",
  "ямар",
  "ухаж",
  "зууш",
  "богд",
  "халх",
  "цааш",
  "орон",
  "гойд",
  "сайн",
  "юмны",
  "бага",
  "юмаа",
  "хойч",
  "юмыг",
  "амьд",
  "гээч",
  "ашиг",
  "өсөн",
  "нэрж",
  "эвэр",
  "байв",
  "цшнх",
  "мөөн",
  "хөөө",
  "айлд",
  "бөөн",
  "дунд",
  "арай",
  "сүйд",
  "гуйж",
  "цоно",
  "архи",

  "цаас",
  "овоо",
  "үгээ",
  "таны",
  "хувь",
  "танд",
  "жилд",
  "голж",
  "майд",
  "өдий",
  "өвөр",
  "үнээ",
  "дуун",
  "хүүе",
  "үхэр",
  "өнөө",
  "унав",
  "одоо",
  "биөд",
  "нааж",
  "хоёр",
  "цагт",
  "эмий",
  "ямар",
  "үрэл",
  "харц",
  "сайн",
  "баяр",
  "багц",
  "оёод",
  "нэгд",
  "пайз",
  "үүнд",
  "тийн",
  "үнэр",
  "зовж",
  "идэж",
  "уярч",
  "янаг",
  "хайр",
  "зүүд",
  "адил",
  "цаст",
  "эзэн",
  "урьд",
  "уран",
  "шүүс",
  "бэрх",
  "наад",
  "ашиг",
  "хийө",
  "овоо",
  "аяга",
  "төвд",
  "алий",
  "оточ",
  "увуу",
  "үзэж",
  "ямар",
  "толь",
  "үүрд",
  "явъя",
  "утас",
  "сүүн",
  "зооч",

  "бууж",
  "замд",
  "орой",
  "өгөн",
  "мөнх",
  "хурц",
  "хөөр",
  "асга",
  "үзэв",
  "усан",
  "зөөж",

  "тэнд",
  "асга",
  "нурж",
  "зүрх",
  "тийш",
  "хөөх",
  "хавь",
  "суув",
  "алин",
  "арай",
  "ахиж",
  "тэнд",
  "дайд",
  "олох",
  "наан",
  "үүлс",
  "холд",
  "одож",
  "дэнс",
];
export const mon4LetterBig = [
  ("Гээд",
  "Хамт",
  "Яваа",
  "Очих",
  "Хага",
  "Алга",
  "Бэрд",
  "Яхир",
  "Байх",
  "Амар",
  "Гарч",
  "Дээр",
  "Хоёр",
  "Ёсыг",
  "Хоёр",
  "Явах",
  "Дээр",
  "Яваа",
  "Байн",
  "Байн",
  "Гэрт",
  "Очих",
  "Үест",
  "Гарч",
  "Хүрч",
  "Ажээ",
  "Ирэх",
  "Яваа",
  "Гээд",
  "Хоёр",
  "Өгье",
  "Гээд",
  "Өмнө",
  "Хийж",
  "Гэрт",
  "Үсээ",
  "Тойг",
  "Байх",
  "Зүүн",
  "Орны",
  "Өмнө",
  "Эмээ",
  "Мэнд",
  "Зуур",
  "Идээ",
  "Ажин",
  "Ямар",
  "Явна",
  "Ажил",
  "Хийх",
  "Өнгө",
  "Яхир",
  "Гээд",
  "Үнэн",
  "Байх",
  "Нүүр",
  "Ажил",
  "Гэнэ",
  "Байх",
  "Зааж",
  "Нааш",
  "Хааш",
  "Байх",
  "Ажил",
  "Хийх",
  "Яваа",
  "Үзэх",
  "Чамд",
  "Ямар",
  "Шинэ",
  "Юунд",
  "Минь",
  "Өрөм",
  "Алив",
  "Охин",
  "Шинэ",
  "Тавь",
  "Хэлж",
  "Уруу",
  "Чинь",
  "Яваа",
  "Эвий",
  "Саад",
  "Болж",
  "Аяыг",
  "Дээр",
  "Тэгж",
  "Чинь",
  "Ярьж",
  "Чинь",
  "Буга",
  "Алах",
  "Арьс",
  "Эцэг",
  "Тийм",
  "Тэгж",
  "Одоо",
  "Тийм",
  "Байх",
  "Утга",
  "Улам",
  "Учир",
  "Доод",
  "Хэгз",
  "Зууж",
  "Биөэ",
  "Биөэ",
  "Өрөм",
  "Эцэг",
  "Охин",
  "Ажна",
  "Хийх",
  "Атал",
  "Дээр",
  "Сайт",
  "Гэгч",
  "Хийх",
  "Юмаа",
  "Дээр",
  "Чинь",
  "Яана",
  "Үгүй",
  "Чинь",
  "Хүнд",
  "Байх",
  "Өмнө",
  "Ямар",
  "Нээж",
  "Лонх",
  "Хамт",
  "Хоёр",
  "Боов",
  "Буян",
  "Чинь",
  "Яваг",
  "Минь",
  "Галд",
  "Хийж",
  "Хийж",
  "Өгөх",
  "Нааш",
  "Минь",
  "Чинь",
  "Үгүй",
  "Тийм",
  "Гээд",
  "Хойш",
  "Арга",
  "Хүнд",
  "Юунд",
  "Байх",
  "Нүүр",
  "Хийх",
  "Минь",
  "Тээр",
  "Чинь",
  "Хойш",
  "Хийж",
  "Уруу",
  "Гарч",
  "Одно",
  "Охин",
  "Хоёр",
  "Идэх",
  "Өрөм",
  "Боож",
  "Хийж",
  "Өгнө",
  "Хээр",
  "Удаа",
  "Чигт",
  "Авах",
  "Өдөр",
  "Давж",
  "Шөнө",
  "Хоёр",
  "Арай",
  "Ядан",
  "Ирнэ",
  "Яана",
  "Минь",
  "Хавь",
  "Чинь",
  "Минь",
  "Бууг",
  "Яриа",
  "Ирэх",
  "Цөөн",
  "Хань",
  "Ижил",
  "Өөрт",
  "Гэрт",
  "Байж",
  "Хээр",
  "Ганц",
  "Удаа",
  "Явах",
  "Учир",
  "Хэлж",
  "Өдөр",
  "Гэрт",
  "Хийж",
  "Дээр",
  "Үзнэ",
  "Охин",
  "Хийж",
  "Охин",
  "Очиж",
  "Юмаа",
  "Үзэх",
  "Үгүй",
  "Хийж",
  "Гэрт",
  "Харж",
  "Сахь",
  "Өдөр",
  "Овыг",
  "Хийж",
  "Харж",
  "Дээр",
  "Багш",
  "Болж",
  "Олон",
  "Ярих",
  "Хийж",
  "Юмаа",
  "Дээр",
  "Ярьж",
  "Авъя",
  "Түүн",
  "Уруу",
  "Харж",
  "Чинь",
  "Ямар",
  "Чинь",
  "Эмэн",
  "Байх",
  "Байж",
  "Сөөм",
  "Яхир",
  "Учир",
  "Ярих",
  "Төрж",
  "Гуай",
  "Чинь",
  "Төрж",
  "Эмээ",
  "Улам",
  "Баян",
  "Болж",
  "Амин",
  "Үнэн",
  "Минь",
  "Чинь",
  "Хөрс",
  "Болж",
  "Чинь",
  "Түүн",
  "Минь",
  "Чинь",
  "Сууж",
  "Ярьж",
  "Байх",
  "Минь",
  "Байх",
  "Байх",
  "Ихэд",
  "Эцэг",
  "Дээр",
  "Ихэд",
  "Төгс",
  "Олон",
  "Алга",
  "Болж",
  "Тивд",
  "Өвөг",
  "Эцэг",
  "Түүр",
  "Зуун",
  "Өмнө",
  "Удам",
  "Олон",
  "Дээр",
  "Ялаа",
  "Чинь",
  "Нүүж",
  "Алга",
  "Байж",
  "Үгүй",
  "Өвөг",
  "Дээр",
  "Ажил",
  "Ажил",
  "Байх",
  "Минь",
  "Ухаж",
  "Юунд",
  "Хийж",
  "Хэлж",
  "Өөрт",
  "Яана",
  "Чинь",
  "Тэгж",
  "Зууш",
  "Болж",
  "Байн",
  "Байн",
  "Олон",
  "Зуун",
  "Богд",
  "Чинь",
  "Өмнө",
  "Халх",
  "Юмаа",
  "Ухаж",
  "Цааш",
  "Орон",
  "Гойд",
  "Тийм",
  "Олон",
  "Гээд",
  "Яана",
  "Галд",
  "Хийх",
  "Ганц",
  "Болж",
  "Удаа",
  "Гээд",
  "Хоёр",
  "Уруу",
  "Сайн",
  "Юмны",
  "Бага",
  "Хойч",
  "Юмыг",
  "Арай",
  "Тийм",
  "Чинь",
  "Байх",
  "Амьд",
  "Охин",
  "Яана",
  "Үгүй",
  "Алга",
  "Гээч",
  "Ашиг",
  "Байх",
  "Өсөн",
  "Минь",
  "Гээд",
  "Хойш",
  "Нүүр",
  "Харж",
  "Байх",
  "Нэрж",
  "Ажил",
  "Хийж",
  "Хоёр",
  "Удаа",
  "Арьс",
  "Тийм",
  "Эвэр",
  "Гэнэ",
  "Байв",
  "Цшнх",
  "Авах",
  "Арай",
  "Мөөн",
  "Гээд",
  "Уруу",
  "Чинь",
  "Хөөө",
  "Эвэр",
  "Гээд",
  "Эвэр",
  "Гээд",
  "Айлд",
  "Чинь",
  "Бөөн",
  "Дунд",
  "Сууж",
  "Чинь",
  "Чинь",
  "Гээд",
  "Эвэр",
  "Ажил",
  "Сүйд",
  "Гуйж",
  "Цааш",
  "Цоно",
  "Чинь",
  "Хийх",
  "Хүнд",
  "Минь",
  "Гээд",
  "Айлд",
  "Чинь",
  "Хоёр",
  "Архи",
  "Чинь",
  "Ажил",
  "Гээд",
  "Цаас",
  "Амар",
  "Ажил",
  "Минь",
  "Байх",
  "Гээд",
  "Ашиг",
  "Чинь",
  "Овоо",
  "Хүрч",
  "Чинь",
  "Тэгж",
  "Хэлж",
  "Гуай",
  "Минь",
  "Үгээ",
  "Таны",
  "Хувь",
  "Танд",
  "Өмнө",
  "Болж",
  "Хийж",
  "Зуур",
  "Гээд",
  "Жилд",
  "Гээд",
  "Гуай",
  "Гээд",
  "Голж",
  "Сүйд",
  "Майд",
  "Болж",
  "Арай",
  "Өдий",
  "Хүрч",
  "Эвэр",
  "Орон",
  "Ямар",
  "Хүрч",
  "Гээч",
  "Нэрж",
  "Хойш",
  "Хүнд",
  "Чинь",
  "Минь",
  "Гээд",
  "Тэгж",
  "Өвөр",
  "Хоёр",
  "Ганц",
  "Тийм",
  "Ямар",
  "Яриа",
  "Сайн",
  "Үнээ",
  "Дуун",
  "Хүүе",
  "Чинь",
  "Үхэр",
  "Биөэ",
  "Учир",
  "Охин",
  "Өдий",
  "Ярих",
  "Байх",
  "Учир",
  "Хоёр",
  "Өнөө",
  "Чинь",
  "Унав",
  "Орон",
  "Дээр",
  "Очиж",
  "Яана",
  "Гээд",
  "Зуур",
  "Нээж",
  "Биөд",
  "Нааж",
  "Чинь",
  "Байх",
  "Дээр",
  "Эмээ",
  "Гээд",
  "Хүрч",
  "Цагт",
  "Гээд",
  "Эмээ",
  "Хоёр",
  "Эмий",
  "Гээч",
  "Байх",
  "Чинь",
  "Үрэл",
  "Одоо",
  "Хийж",
  "Тийм",
  "Сайн",
  "Охин",
  "Минь",
  "Гээд",
  "Харц",
  "Байх",
  "Байх",
  "Үнэн",
  "Ярьж",
  "Ярьж",
  "Яриа",
  "Үгүй",
  "Тийм",
  "Яхир",
  "Биөэ",
  "Харж",
  "Баяр",
  "Өдөр",
  "Өнгө",
  "Ажээ",
  "Багц",
  "Боож",
  "Хийж",
  "Оёод",
  "Нэгд",
  "Пайз",
  "Үүнд",
  "Чинь",
  "Тийн",
  "Үнэр",
  "Үнэр",
  "Харж",
  "Үгүй",
  "Цагт",
  "Байх",
  "Гэнэ",
  "Чинь",
  "Очиж",
  "Ихэд",
  "Зовж",
  "Өнөө",
  "Өдөр",
  "Үгүй",
  "Байж",
  "Идэж",
  "Гэнэ",
  "Гээд",
  "Уярч",
  "Ямар",
  "Янаг",
  "Хэлж",
  "Харц",
  "Хайр",
  "Тийм",
  "Учир",
  "Зүүд",
  "Болж",
  "Минь",
  "Гээд",
  "Адил",
  "Гээд",
  "Цаст",
  "Дээр",
  "Учир",
  "Юмаа",
  "Овоо",
  "Охин",
  "Болж",
  "Дээр",
  "Юмаа",
  "Эзэн",
  "Бэрд",
  "Байх",
  "Гээд",
  "Урьд",
  "Өмнө",
  "Тийм",
  "Уран",
  "Хоёр",
  "Юмаа",
  "Шүүс",
  "Гэнэ",
  "Хойш",
  "Дээр",
  "Чинь",
  "Үгүй",
  "Охин",
  "Гэнэ",
  "Тийм",
  "Амар",
  "Чинь",
  "Бэрх",
  "Юмыг",
  "Гээд",
  "Минь",
  "Наад",
  "Чинь",
  "Харж",
  "Гээд",
  "Байх",
  "Сайн",
  "Хийх",
  "Байх",
  "Зааж",
  "Хийө",
  "Явна",
  "Минь",
  "Аяга",
  "Минь",
  "Минь",
  "Төвд",
  "Алий",
  "Үгүй",
  "Оточ",
  "Увуу",
  "Үгүй",
  "Үзэж",
  "Ямар",
  "Орон",
  "Толь",
  "Төвд",
  "Чамд",
  "Чинь",
  "Үнэн",
  "Гээд",
  "Өнөө",
  "Үүрд",
  "Явъя",
  "Дээр",
  "Дээр",
  "Дээр",
  "Минь",
  "Гээд",
  "Гээд",
  "Утас",
  "Сүүн",
  "Зооч",
  "Харц",
  "Чинь",
  "Минь",
  "Гээд",
  "Байх",
  "Бууж",
  "Минь",
  "Охин",
  "Хамт",
  "Үзнэ",
  "Учир",
  "Замд",
  "Явах",
  "Орой",
  "Очиж",
  "Байж",
  "Өгөн",
  "Мөнх",
  "Цаст",
  "Орой",
  "Хурц",
  "Байн",
  "Байн",
  "Баяр",
  "Хөөр",
  "Ядан",
  "Олон",
  "Биөд",
  "Асга",
  "Гээд",
  "Өнгө",
  "Үнэр",
  "Болж",
  "Асга",
  "Үзэв",
  "Усан",
  "Ядан",
  "Гуай",
  "Одоо",
  "Хоёр",
  "Дээр",
  "Хоёр",
  "Цааш",
  "Зөөж",
  "Байж",
  "Дээр",
  "Орой",
  "Минь",
  "Хоёр",
  "Бага",
  "Тэнд",
  "Нурж",
  "Сүйд",
  "Хоёр",
  "Уруу",
  "Дээр",
  "Бөөн",
  "Бөөн",
  "Зүрх",
  "Гээд",
  "Тийш",
  "Усан",
  "Дээр",
  "Яваа",
  "Яваа",
  "Дээр",
  "Байх",
  "Зүрх",
  "Өдөр",
  "Яваа",
  "Баяр",
  "Хөөх",
  "Үгүй",
  "Хоёр",
  "Байн",
  "Байн",
  "Дунд",
  "Нүүж",
  "Суув",
  "Үнэр",
  "Алин",
  "Сууж",
  "Шөнө",
  "Яана",
  "Минь",
  "Зовж",
  "Сүйд",
  "Явна",
  "Чинь",
  "Гээд",
  "Гарч",
  "Бөөн",
  "Цааш",
  "Алга",
  "Хоёр",
  "Ахиж",
  "Байн",
  "Байн",
  "Хоёр",
  "Гээч",
  "Гээд",
  "Үзэж",
  "Хоёр",
  "Юмаа",
  "Учир",
  "Дайд",
  "Байх",
  "Ихэд",
  "Олох",
  "Байж",
  "Наан",
  "Зүүн",
  "Өмнө",
  "Үүлс",
  "Орой",
  "Холд",
  "Одож",
  "Хоёр",
  "Улам",
  "Улам",
  "Дэнс",
  "Охин"),
];
export const mon3Lettersmall = [
  "ойн",
  "тэр",
  "дээ",
  "том",
  "сан",
  "зам",
  "шиг",
  "мар",
  "гэж",
  "хар",
  "нэг",
  "хүн",
  "биш",
  "тун",
  "янз",
  "тал",
  "руу",
  "хөв",
  "хус",
  "нүд",
  "мөн",

  "мөн",
  "дуу",
  "орж",
  "ийм",
  "энэ",
  "эрж",
  "том",
  "даа",
  "тэс",
  "цай",
  "нэр",
  "хэн",
  "хаа",
  "энд",
  "энэ",
  "энд",
  "бий",
  "өгч",
  "хий",
  "биз",
  "авч",
  "ийм",
  "зан",
  "хүү",
  "цай",
  "гэр",
  "олж",
  "бол",
  "цол",
  "бас",
  "гол",
  "түс",
  "тас",
  "муу",
  "яаж",
  "хот",
  "үнэ",
  "уур",
  "тэр",
  "биө",
  "гэм",
  "ууж",
  "яах",
  "ийм",
  "ирж",
  "гай",
  "энд",
  "дор",
  "гэв",
  "хэд",
  "нар",
  "зүг",
  "аав",
  "тат",
  "жил",
  "мөр",
  "хош",
  "тэр",
  "буй",
  "уул",
  "энэ",
  "ойр",
  "энэ",
  "бүр",
  "мал",
  "хүү",
  "бай",
  "шүү",
  "явж",
  "хүн",
  "бус",
  "айх",
  "өрж",
  "дэн",
  "өөр",
  "энэ",
  "дуу",
  "энэ",
  "энэ",
  "түр",
  "пээ",
  "үйл",
  "бид",
  "улс",

  "сая",
  "ний",
  "эрт",
  "мэт",
  "энэ",
  "хүн",
  "бид",
  "энэ",
  "хэд",
  "хүн",
  "маш",
  "доо",
  "бүх",
  "энэ",
  "энэ",
  "бид",
  "энэ",
  "дүү",
  "тус",
  "хар",
  "ийн",
  "хан",
  "хан",
  "өнө",
  "мөн",
  "ард",
  "мод",
  "хөх",
  "үед",
  "даг",
  "зөв",
  "төл",
  "олз",
  "энэ",
  "аль",
  "гэх",
  "анх",
  "өөд",
  "энэ",
  "тэр",
  "цол",
  "шил",
  "нэг",
  "шар",
  "гар",
  "чүү",
  "гял",
  "цал",
  "сох",
  "бэх",
  "тэр",
  "шал",
  "цол",
  "шив",
  "энэ",
  "энэ",
  "ном",
  "энэ",
  "дур",
  "хөл",
  "мөн",
  "наг",
  "ийм",
  "улс",
  "лут",
  "энэ",
  "шүд",
  "мах",
  "бор",
  "аль",
  "юун",
  "хэн",
  "хүн",
  "ойн",
  "эрт",
  "нэг",
  "хэд",
  "сар",
  "над",
  "хөө",
  "эрх",
  "ойн",
  "аав",
  "энэ",
  "ишш",
  "хүү",
  "хүү",
  "аль",
  "шуу",
  "ийм",
  "энэ",
  "ойр",
  "дув",
  "хол",
  "таг",
  "өвс",
  "ойд",
  "үүр",
  "тэр",
  "хад",
  "бэл",
  "зэд",
  "арц",
  "эгц",
  "энэ",
  "онь",
  "тэд",
  "тун",
  "үүл",
  "тэр",
  "энэ",
  "ийш",
  "сүр",
  "цог",
  "угт",
  "энэ",
  "зай",
  "тэр",
  "айж",
  "аав",
  "хос",
  "тэр",
  "хүч",
  "хос",
  "бид",
  "уян",
  "ааг",
  "ааг",
  "оны",
];
export const mon3LetterBig = [
  "Ойн",
  "Тэр",
  "Дээ",
  "Том",
  "Сан",
  "Зам",
  "Шиг",
  "Мар",
  "Гэж",
  "Хар",
  "Нэг",
  "Хүн",
  "Биш",
  "Тун",
  "Янз",
  "Тал",
  "Руу",
  "Хөв",
  "Хус",
  "Нүд",
  "Мөн",
  "Мөн",
  "Дуу",
  "Орж",
  "Ийм",
  "Энэ",
  "Эрж",
  "Том",
  "Даа",
  "Тэс",
  "Цай",
  "Нэр",
  "Хэн",
  "Хаа",
  "Энд",
  "Энэ",
  "Энд",
  "Бий",
  "Өгч",
  "Хий",
  "Биз",
  "Авч",

  "Ийм",
  "Зан",
  "Хүү",
  "Цай",
  "Гэр",
  "Олж",
  "Бол",
  "Цол",

  "Бас",
  "Гол",
  "Түс",
  "Тас",
  "Муу",
  "Яаж",
  "Хот",
  "Үнэ",
  "Уур",
  "Тэр",
  "Биө",
  "Гэм",
  "Ууж",
  "Яах",
  "Ийм",
  "Ирж",
  "Гай",
  "Энд",
  "Дор",
  "Гэв",
  "Хэд",
  "Нар",
  "Зүг",
  "Аав",
  "Тат",
  "Жил",
  "Мөр",
  "Хош",
  "Тэр",
  "Буй",
  "Уул",
  "Энэ",
  "Ойр",
  "Энэ",
  "Бүр",
  "Мал",
  "Хүү",
  "Бай",
  "Шүү",
  "Явж",
  "Хүн",
  "Бус",
  "Айх",
  "Өрж",
  "Дэн",
  "Өөр",
  "Энэ",
  "Дуу",
  "Энэ",
  "Энэ",
  "Түр",
  "Пээ",
  "Үйл",
  "Бид",
  "Улс",
  "Сая",
  "Ний",
  "Эрт",
  "Мэт",
  "Энэ",
  "Хүн",
  "Бид",
  "Энэ",
  "Хэд",
  "Хүн",
  "Маш",
  "Доо",
  "Бүх",
  "Энэ",
  "Энэ",
  "Бид",
  "Энэ",
  "Дүү",
  "Тус",
  "Хар",
  "Ийн",
  "Хан",
  "Хан",
  "Өнө",
  "Мөн",
  "Ард",
  "Мод",
  "Хөх",
  "Үед",
  "Даг",
  "Зөв",
  "Төл",
  "Олз",
  "Энэ",
  "Аль",
  "Гэх",
  "Анх",
  "Өөд",
  "Энэ",
  "Тэр",
  "Цол",
  "Шил",
  "Нэг",
  "Шар",
  "Гар",
  "Чүү",
  "Гял",
  "Цал",
  "Сох",
  "Бэх",
  "Тэр",
  "Шал",
  "Цол",
  "Шив",
  "Энэ",
  "Энэ",
  "Ном",
  "Энэ",
  "Дур",
  "Хөл",
  "Мөн",
  "Наг",
  "Ийм",
  "Улс",
  "Лут",
  "Энэ",
  "Шүд",
  "Мах",
  "Бор",
  "Аль",
  "Юун",

  "Хэн",
  "Хүн",
  "Ойн",
  "Эрт",
  "Нэг",
  "Хэд",
  "Сар",
  "Над",
  "Хөө",
  "Эрх",
  "Ойн",
  "Аав",
  "Энэ",
  "Ишш",

  "Хүү",
  "Хүү",
  "Аль",
  "Шуу",
  "Ийм",
  "Энэ",
  "Ойр",
  "Дув",
  "Хол",
  "Таг",
  "Өвс",
  "Ойд",
  "Үүр",
  "Тэр",
  "Хад",
  "Бэл",
  "Зэд",
  "Арц",
  "Эгц",
  "Энэ",
  "Онь",
  "Тэд",
  "Тун",
  "Үүл",
  "Тэр",
  "Энэ",
  "Ийш",
  "Сүр",
  "Цог",
  "Угт",
  "Энэ",
  "Зай",
  "Тэр",
  "Айж",
  "Аав",
  "Хос",
  "Тэр",
  "Хүч",
  "Хос",
  "Бид",
  "Уян",
  "Ааг",
  "Ааг",
  "Оны",
];
export const monUguulber = [
  "Цэнхэр шар өнгөний дундаас ногоон өнгө гардаг.",
  "Монгол улсын үндсэн хууль 6 бүлэгтэй.",
  `"Бачим" гэж яаралтай гэсэн утгийг илэрхийлнэ.`,
  `Мэлхийг монгол бичигт "мэлэхэй" гэж бичдэг.`,
  "Хүргэний хүүхдийг зээ гэнэ.",
  "Үнэгний зулзагыг гавар гэнэ.",
  "Дондогдулам нь Монголын хамгийн сүүлчийн хааны хатан юм.",
  "Дэлхийн 71%-ийг ус эзэлдэг.",
  "Хүний биеийн 70 хувийг ус эзэлдэг.",

  "Монгол улсын төв цэг Өвөрхангай аймгийн Бүрд суманд байрладаг.",
  `"Цаглавар" гэж цаг тооны бичгийг хэлнэ`,
  "Ноолуур нь маш нарийн зөөлөн ноос юм",
  `Дэлхийн хамгийн жижиг хот улс "Ватикан" юм.`,
  `Монголын нууц товчоонд гардаг Торголжин баяны гэргийг Монголжингуа гэдэг.`,
  `Ёлын ам Өмнөговь аймагт байрладаг.`,
  `Өвөрхангай аймгийн төвийг Арвайхээр гэдэг.`,
  `Чингис хаан хамгийн сүүлд Тангуд улстай байлдсан.`,
  `Тэмээ усаа бөхөндөө нөөцөлдөг.`,
  "Хаа, гуяндаа түшиг, хамар амандаа түшиг.",
  "Эзэн хичээвэл, заяа хичээнэ.",
  "Эрдмийг хичээлээр сурдаг, Эрлийг сургаар олдог.",
  "Эзэн хичээвэл, заяа хичээнэ.",
  "Эрдмийг хичээлээр сурдаг, Эрлийг сургаар олдог.",
  "Ухаан далай номоос эхтэй, усан далай дуслаас эхтэй.",
  "Хийвэл бүү ай, айвал бүү хий.",
  "Аяганы хариу өдөртөө, агтны хариу жилдээ.",
  "Эрхийг сурахаарь, бэрхийг сур.",
  "Хүн болох багаасаа, хүлэг болох унаганаасаа.",
  "Ажил хийвэл дуустал, давс хийвэл уустал.",
  "Аавын бийд хүнтэй танилц, агтны бийд газар үз.",
  "Ам алдвал барьж болдоггүй, агт алдвал барьж болдог.",
  "Бурмаа тэтгэхээр урмаар тэтгэ.",
  "Бүгдээрээ хэлэлцвэл буруугүй, бүлээн усаар угаавал хиргүй.",
  "Ажил хийж хүн болдог, ар давж хүлэг болдог",
  "Хариутай бол бариутай",
  "Сайн нэрийг хүсэвч үл олох, муу нэрийг хусавч үл арилах.",
  "Нэр хугарах өдрийнх, нэр олох насных.",
  "Замын хүзүү урт, зааны хүзүү богино.",
  "Дассан газрын даавуу зөөлөн.",
  "Гэрт орж эм, гадаа гарч эр болох.",
  "Сайн хүн нэг үгтэй, сайн морь нэг явдалтай.",
  "Түрүүлж ургасан сүүлнээс, сүүлд ургасан эвэр.",
  "Төлөөр баяжиж шөлөөр цадах.",
  "Буурлаас үгс сонс, болсноос ам хүр.",
  "Амны билгээс ашдын билэг.",
  "Дархан хүн бурхан ухаантай.",
  "Эрт босвол нэгийг үзнэ, Орой унтвал нэгийг дуулна.",
  "Зан сайтай айлд хүн цуглана, загас сайтай нууранд шувуу цуглана",
  "Олны хүч, Оломгүй далай.",
  "Нойрноос морио, чөмөгнөөс хутгаа.",
  "Дөч хүрсэн эр, дөрвөө дарсан ат.",
  "Өглөөний нарыг наранд бүү тооц, өсөхийн жаргалыг жаргалд бүү тооц.",
  "Урмыг нь хугалахаар, ууцыг нь хугал.",
  "Зангаа мэдэлцвэл хэлэлцэхэд амар, замаараа явбал моринд амар.",
  "Замын нохой хуцаж л байдаг, Жингийн цуваа явж л байдаг.",
  "Загасчны морь усгүй.",
  "Залхуугийн гадаа түлээгүй, залгидгийн гэрт хоолгүй.",
  "Өдөр алдаж шөнө.",
  "Хүний эрээн дотроо, могойн эрээн гаднаа.",
  "Суусан цэцнээс, Явсан тэнэг дээр.",
  "Хэлэх үгийг эзэнд нь хэл, Тавих морийг ижилд нь тавь.",
  "Заяат хүн нагацтай, зандан мод үндэстэй.",
  "Заяанаас зайлж болдоггүй, учирлаас урваж болдоггүй.",
  "Морь ядарвал эзэн явган, Төр ядарвал иргэд нүцгэн.",
  "Сайхан үгээр илбэдэж, уран үгээр унтуулах.",
  "Дэрээ элээхээр, дэвсээ элээ.",
  "Нохойгүй айл дүлийтэй адил, номгүй айл сохортой адил.",
  "Муу хүн идсэнээ, сайн хүн явснаа.",
  "Суусан газраасаа шороо атгах.",
  "Сайхан хүүхэн сахалтай.",
  "Эсгий хийх газар, нохой хэрэггүй.",
  "Морьтны хишиг явганд.",
  "Муу хүн шинжээч, мухар үхэр сэжээч.",
  "Дураараа дургиж, дунд чөмгөөрөө жиргэх.",
  "Дур дураа голохгүй, дунд чөмөг сүүжээ голохгүй.",
  "Их санасан газар есөн шөнө хоосон.",
  "Бухын доодохыг харж, үнэг турж үхэх.",
  "Амьд явбал, алтан аяганаас ус ууна.",
  "Эхийг нь эцээж, тугалыг нь тураахгүй байх.",
  "Сонин дээрээ соохолзож, сониноо буурахаар хоохолзох.",
  "Гэдэс нь цадсан ч, сэтгэл нь цадахгүй.",
  "Усыг нь уувал, ёсыг нь дагах.",
  "Сайнтай муутай сав дүүрдэг.",
  "Хөгшин азарга жороо сурах.",
  "Урт хошуу хүзүү орооно.",
  "Түрүүлж дуугарсан хөхөөний ам хөлдөнө.",
  "Уур биеийг зовооно, уул морийг зовооно.",
  "Авсан хүн нэг тамтай, алдсан хүн арван тамтай.",
  "Уяанаасаа алдуурсан нохой мэт.",
  "Хаврын хавсарга хавирга нэвт.",
  "Дүүрсэн хэрэг, дүмбийсэн толгой.",
  "Ард ч багтахгүй, өвөрт ч багтайхгүй.",
  "Муу хүн архинд чангарна, олсон дээс усанд чангарна.",
  "Могой гурав тасравч гүрвэлийн чинээ.",
  "Айсан хүнд, аргал хөдлөх.",
  "Залийн дараа зарга, завхайн дараа өвчин, залхуугийн дараа хоосон.",
  "Туйлбаргүй хүнээр нөхөр хийдэггүй, туургагүй гэрээр өвлийг давдаггүй.",
  "Нарнаас хоргодож болдог, наснаас хоргодож болдоггүй.",
  "Хүнийг аргаар, хүлгийг уургаар.",
  "Дуутай бороо хургүй, цуутай хүүхэн хуримгүй.",
  "Нохой сайтын хот амгалан, ноён сайтын ард жаргалтай.",
  "Хатирч морь унахад сайхан, хашир хүнтэй нөхөрлөх сайхан.",
  "Архи уурыг нэмнэ, аргал галыг нэмнэ.",
  "Эдээрээ оролдвол эвдэхийн тэмдэг, Эхнэрээрээ оролдвол салахын тэмдэг.",
  "Мушгиа модыг хагалахад бэрх, мулгуу хүнийг дагуулахад бэрх.",
  "Тэнгэрийн муухай арилдаг, хүний муухай арилдаггүй.",
  "Үг сөрвөл хэрүүл, үүл сөрвөл бороо.",
  "Бэлгийн морины шүдийг үздэггүй.",
  "Харамласан юм хар нохойн аманд.",
  "Булгаа ширгээсэн нутаг, нутаг биш, угаа алдсан хүн, хүн биш.",
  "Ганцаараа идсэн гахай таргалдаггүй, Олуулаа идсэн оготно таргалдаг.",
  "Зуун задгай, Жаран хагархай.",
  "Хүн нэрээ,Тогос өдөө.",
  "Нэр хугарахаар,Яс хугар.",
  "Эм хэдий гашуун ч өвчинд тустай, үг хэдий хатуу ч явдалд тустай.",
  "Хүн хэдий сайн ч хэлэхээс нааш санахгүй, Цаас хэдийн нимгэн ч чичихээс нааш цоорохгүй.",
  "Ухаангүй ноёнд, урагшгүй албат.",
  "Хүний хуучин, дээлийн шинэ нь дээр.",
  "Чамд инээдэм Надад ханиадам",
  "Аавдаа авгай авахыг заах",
  "Аргаа барж аавынхаа толгойг маажих",
  "Залуу хүнд сургамж хэрэгтэй хөгшин хүнд өргөмж хэрэгтэй",
  "Нэг тэрэгний хоёр дугуй",
  "Таарсан таар шуудайнууд",
  "Төөрсөөр төөрсөөр төрөлдөө",
  "Чихээрээ дуулсан юм худалд дөт, нүдээрээ харсан юм үнэнд дөт",
  "Буруу замаар будаа тээвэл, буцахдаа шороо тээнэ",
  "Хоёр хар хэрээ хэн хэнийхээ харыг гайхна",
  "Гаднаа гяланцаг дотроо паланцаг",
  "Болсон нь борвиороо түүхий нь түрийгээрээ",
  "Муу санаа биеэ отно",
  "Дуугүй хүний доодох нойтон",
  "Тэнхлүүн явахад тэмээгээр тусалснаас тэвдэж явахад тэвнээр тусалсан нь дээр",
  "Үзээгүй юмаа үзэж үхэр буугаа тавих",
  "Сэжгээр өвдөж сүжгээр эдгэнэ",
  "Завхай хүн ханьгүй залхуу хүн хоолгүй",
  "Ноёнтой ханилахаар нохойтой ханил",
  "Идсэн эрүү хувхайрч идүүлсэн бут ургадаг",
  "Хошуу нэмэрээр хуруу нэм",
  "Хэлэхэд амархан хийхэд хэцүү",
  "Залагдаж ирсэн залан мэт",
  "Санаа муут яван хатна сарьсан багваахай наранд хатна",
  "Сайн санааны үзүүрт шар тос",
  "Шалихгүй эр гэртээ хаан шар шувуу үүрэндээ хаан",
  "Алтны дэргэдэх гууль шарлана",
  "Гуймхай мөртөө голомтгой",
  "Бурхангүй газар бумба галзуурна",
  "Гар бариад бугуй барих",
  "Хүйтний ам наашилж хөхүүрийн ам цаашлах",
  "Хүний бага нь явж шувууны бага нь жиргэдэг",
  "Өндөг шиг өөгүй хүн гэж үгүй",
  "Аавын хүү адилгүй арван хуруу тэгшгүй",
  "Аваагүй байхад авгай сайхан алаагүй байхад үнэг сайхан",
  "Гай газар доороос гахай модон дотроос",
  "Дааганаас унаж үхдэггүй даравгараасаа болж үхдэг",
  "Далай усаар ханадаггүй мэргэд номоор ханадаггүй",
  "Даахин дор баатар дахан дор хүлэг",
  "Сүжгээс бурхан сэжгээс чөтгөр",
  "Муу үг модон улаатай",
  "Бодоод бодоод бодын шийр дөрөв",
  "Олон хэлвэл улиг цөөн хэлвэл билэг",
  "Нүгэл нь нүдээрээ гарах",
  "Загатнасан газар маажих",
  "Хүний сайныг ханилан байж мэддэг, хүлгийн сайныг унан байж мэддэг",
  "Өөдлөх айлын өнгө үүднээсээ",
  "Гадаах нь гэртээ ороогүй, гэр дэх нь гэдсэндээ ороогүй",
  "Уйлах ч хэцүү инээх ч хэцүү",
  "Ичсэн хүн хүн алж айсан хүн адуу үргээнэ",
  "Залхуу хүнд шалтаг мундахгүй, зусарч хүнд үг мундахгүй",
  "Замаар явбал моринд амар, зангаар явбал биенд амар",
  "Зөөлөн үгэнд хүн бөхийж зүлэгтэй газар морь хөрвөөдөг",
  "Ороо морийг уургаар ууртай хүнийг аргаар",
  "Буцах бэрд үнээ нийлэх хамаагүй",
  "Сэгсгэр ч гэсэн ижий минь сиймхий ч гэсэн гэр минь",
  "Зусарч хүн олондоо халтай, зусаг ямаа ишгэндээ халтай",
  "Биеэ мэдвэл хүн, бэлчээрээ мэдвэл мал",
  "Хүргэн хүү хүчтэй, хүзүүний мах амттай.",
  "Гэм нь урдаа, гэмшил нь хойноо.",
  "Үг олдож үхэр холдох.",
  "Бушуу туулай борвиндоо баастай.",
  "Эвт шаазгай буга барих.",
  "Ахаа алд хүндэл, дүүгээ дэлэм хүндэл.",
  "Алтыг нь аваад авдрыг нь хаях.",
  "Зусарч хүн зуны гурван сар, зусаг ямаа хаврын гурван сар.",
  "Эвлэвэл бүтнэ, ховловол гутна.",
  "Сахил хүртээд шал дордов.",
  "Алдыг нь аваад дэлэм дээр нь, атгыг нь аваад чимх дээр нь.",
  "Хойд хормойгоо авч урд хормойгоо нөхөх.",
  "Дундуур дундуур гэсээр долоо дахих.",
  "Зүйргүй үг гэж үгүй зүүдэлгүй дээл гэж үгүй.",
];
